export default {
  common: {
    edit: 'Modifier',
    yes: 'Oui',
    no: 'Non',
    or: 'ou',
    search: 'Chercher',
    none: 'Rien',
    save: 'Sauvegarder',
    error: 'Erreur',
    reset: 'Réinitialiser',
    input: 'Entrée',
    cancel: 'Annuler',
    next: 'Suivant',
    back: 'Retour',
    selectHeaders: 'Sélectionner les en-têtes visibles',
    weekday: 'Jour de la semaine',
    from: 'De',
    delete: 'Supprimer',
    to: 'À',
    deliveryAt: 'Livraison à',
    ok: 'Ok',
    add: 'Ajouter',
    disable: 'Désactiver',
    enable: 'Activer',
    remove: 'Supprimer',
    empty: "Il n'y a rien à voir ici.",
    selectToImport: 'Veuillez sélectionner un fichier à importer',
    selectVenue: 'Veuillez sélectionner un restaurant.',
    import: 'Importer',
    export: 'Exporter',
    legacyExport: 'Export hérité',
    file: 'Fichier',
    apply: 'Appliquer',
    applySelectedFilters: 'Appliquer les filtres sélectionnés',
    filters: 'Filtre',
    orders: 'Commandes',
    overview: "Vue d'ensemble",
    others: 'Autres',
    skip: 'Passer',
    time: 'Heure',
    date: 'Date',
    register: "S'inscrire",
    submit: 'Soumettre',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet élément ? Cette action est irréversible.',
    form: {
      file: 'Fichier',
    },
    all: 'Tous',
    single: 'Unique',
    teedeli: 'Teedeli',
    selectItems: 'Veuillez sélectionner au moins un élément.',
    noSelection: 'Aucune sélection',
    description: 'Description',
    invoice: 'Facture',
    name: 'Nom',
    tag: 'Étiquette',
    tags: 'Étiquettes',
    test: 'Test',
    shoppingCart: 'Panier',
    send: 'Envoyer',
    recommendation: 'Recommandation',
    generate: 'Générer',
    selectAll: 'Tout sélectionner',
    singleImageAllowed: 'Une seule image est autorisée !',
    imageFilesOnly: 'Seuls les fichiers image sont autorisés !',
    fileSizeExceed: 'La taille du fichier dépasse le maximum de {max} Mo !',
    imageMaxSizeNotice: "L'image doit avoir une taille maximale de {max} Mo !",
    copyId: "Copier l'ID",
    copiedToClipboard: 'Copié dans le presse-papiers !',
    imagesDragAndDrop: 'Glisser-déposer',
    browseFiles: 'Parcourir les fichiers',
    videoPreview: 'Aperçu vidéo',
    fileName: 'Nom du fichier',
    fileSize: 'Taille du fichier',
    videoDuration: 'Durée vidéo',
    videoResolution: 'Résolution vidéo',
    uploadProgress: 'Progression du téléchargement',
    uploadVideo: 'Télécharger la vidéo',
    videoFileOnly: 'Fichiers vidéo uniquement !',
    dragAndDropVideoHere: 'Glissez et déposez votre vidéo ici',
    uploadComplete: 'Téléchargement terminé',
  },
  feedback: {
    title: 'Envoyer des commentaires',
    fields: {
      name: 'Nom',
      email: 'E-mail',
      comments: "Que s'est-il passé ?",
    },
    actions: {
      open: 'Ouvrir la boîte de dialogue de retour',
      submit: 'Envoyer des commentaires',
    },
    notification: {
      sent: 'Commentaire envoyé.',
    },
  },
  languageField: {
    add: 'Ajouter autre',
    picker: 'Langue',
  },
  countries: {
    de: 'Allemagne',
    au: 'Autriche',
    fr: 'France',
    li: 'Liechtenstein',
    lu: 'Luxembourg',
    ch: 'Suisse',
    es: 'Espagne',
    is: 'Islande',
    ic: 'Îles Canaries',
    pt: 'Portugal',
    cz: 'République tchèque',
    nl: 'Pays-Bas',
    be: 'Belgique',
    no: 'Norvège',
    dk: 'Danemark',
    se: 'Suède',
    ae: 'Émirats arabes unis',
    lt: 'Lituanie',
    fi: 'Finlande',
    gb: 'Royaume-Uni',
    it: 'Italie',
    om: 'Oman',
  },
  toolbar: {
    selectOrSearchVenue: 'Sélectionner ou rechercher un restaurant...',
    noSelection: 'Aucun restaurant sélectionné',
    copyShortId: "Copier l'ID court",
  },
  masterTypes: {
    web: 'Web',
    terminal: 'Terminal',
  },
  login: {
    caption: 'Smoothr est le raccourci pour la numérisation de votre restaurant.',
  },
  dashboard: {
    index: 'Tableau de bord',
    totalSum: "Chiffre d'affaires total",
    totalVenues: 'Affichage des résultats de {total} restaurants.',
    totalNetSum: "Chiffre d'affaires net total",
    orderSum: 'Nombre de commandes',
    provisionSum: 'Commission',
    form: {
      customerGroup: 'Sélectionner le groupe de clients',
    },
    table: {
      total: 'Total',
      totalNet: 'Total net',
      numberOfOrders: 'Nombre de commandes',
      venue: 'Restaurant',
      readableId: 'ID court',
      provision: 'Commission',
    },
  },
  provision: {
    index: 'Commission',
    overview: "Vue d'ensemble",
    claim: 'Réclamer la commission',
    select: 'Sélectionner ou rechercher un restaurant pour afficher les paiements',
    claimHelp: 'Sélectionnez un restaurant et une période pour réclamer la commission.',
    success: 'Succès',
    sum: 'Somme',
    waiting: 'En attente',
    notClaimed: 'Non réclamé',
    notification: {
      claiming:
        'La commission sera réclamée. Après quelques minutes, veuillez actualiser le site pour voir les changements.',
    },
    form: {
      venue: 'Restaurant',
    },
    table: {
      sum: 'Prix total',
      method: 'Méthode',
      status: 'Statut',
      createdAt: 'Créé le',
      provision: 'Statut de la commission',
      provisionClaimedAt: 'Réclamé le',
    },
  },
  inventory: {
    index: 'Inventaire',
    overview: "Vue d'ensemble",
    stock: 'Stock',
    product: 'Produits',
    add: 'Créer',
    form: {
      stock: 'Stock',
      product: 'Sélectionner des produits',
    },
    table: {
      stock: 'Stock',
      inventoryItems: 'Produits',
      createdAt: 'Créé le',
    },
  },
  company: {
    index: 'Entreprise',
    overview: "Vue d'ensemble",
    general: 'Détails',
    deliveryAddress: 'Adresse de livraison',
    invoiceAddress: 'Adresse de facturation',
    add: 'Créer',
    create: 'Créer',
    edit: 'Modifier',
    form: {
      venue: 'Restaurant',
      name: 'Nom',
      companyCode: 'Code entreprise',
      email: 'E-mail',
      phoneNumber: 'Numéro de téléphone',
      vatNumber: 'TVA',
      orderMinimum: 'Minimum de commande',
      subsidy: 'Subvention',
      subsidyOrderMinimum: 'Minimum de commande pour subvention',
      paymentMethod: 'Méthode de paiement',
      iban: 'IBAN',
      storeDiscount: 'Remise en magasin (%)',
      isPaidByCompany: "Payé par l'entreprise",
      city: 'Ville',
      area: 'Ville la plus proche',
      street: 'Rue',
      streetAddress: 'Adresse',
      number: 'Numéro',
      company: 'Entreprise',
      postalCode: 'Code postal',
      gpsManualInput: 'Saisie manuelle (coordonnées GPS)',
      gpsCorrect: 'Coordonnées GPS correctes ?',
      latitude: 'Latitude',
      longitude: 'Longitude',
      deliveryTime: 'Délai de livraison',
      useDeliveryAddressAsInvoice: "Utiliser l'adresse de livraison comme adresse de facturation",
    },
    table: {
      venue: 'Restaurant',
      name: 'Nom',
      createdAt: 'Créé le',
      companyCode: 'Code entreprise',
      email: 'E-mail',
      phoneNumber: 'Numéro de téléphone',
      vatNumber: 'TVA',
    },
    tabs: {
      general: 'Général',
      openingHours: "Heures d'ouverture",
      deliveryTime: 'Délai de livraison',
    },
    notification: {
      emptyOpeningHours: "Les heures d'ouverture sont vides. Veuillez définir les heures d'ouverture.",
    },
  },
  uiBanner: {
    index: 'Bannière',
    overview: "Vue d'ensemble",
    general: 'Détails',
    add: 'Créer',
    create: 'Créer',
    edit: 'Modifier',
    empty:
      "Il semble que vous n'ayez pas encore ajouté de bannière d'interface utilisateur. Créez votre première bannière maintenant !",
  },
  uiCard: {
    index: 'Carte',
    overview: "Vue d'ensemble",
    general: 'Détails',
    add: 'Créer',
    create: 'Créer',
    edit: 'Modifier',
    empty:
      "Il semble que vous n'ayez pas encore ajouté de carte d'interface utilisateur. Créez votre première carte maintenant !",
  },
  uiSlider: {
    index: 'Curseur',
    overview: "Vue d'ensemble",
    general: 'Détails',
    add: 'Créer',
    create: 'Créer',
    edit: 'Modifier',
    empty:
      "Il semble que vous n'ayez pas encore ajouté de curseur d'interface utilisateur. Créez votre premier curseur maintenant !",
  },
  notification: {
    form: 'Veuillez remplir le formulaire.',
    400: "La demande n'était pas valide.",
    401: 'Vos identifiants ne sont pas valides.',
    422: "Une erreur de validation inattendue s'est produite. Veuillez vérifier le formulaire.",
    404: 'La ressource demandée est introuvable.',
    403: "Vous n'êtes pas autorisé à voir cette page.",
    500: "Une erreur interne du serveur s'est produite.",
    mfa: 'Le code MFA est invalide.',
    unknown: "Une erreur inconnue s'est produite.",
    downloadInProgress:
      "Votre téléchargement sera préparé. Vous pouvez toujours naviguer sur le site. Le téléchargement de votre fichier démarrera automatiquement lorsqu'il sera prêt.",
    downloadFailed: 'Un de vos téléchargements a échoué. Veuillez réessayer plus tard.',
    downloadSuccess: 'Votre téléchargement est prêt !',
    gpsError:
      "La position GPS pour l'adresse fournie n'a pas été trouvée. Veuillez modifier l'adresse ou saisir manuellement les coordonnées GPS.",
    successfulDownload: "L'exportation a été envoyée à votre adresse e-mail",
    retryCheckoutIntegrationAction: 'Réessayer avec succès',
    needOpeningHours: "Veuillez d'abord définir les heures d'ouverture !",
    needDeliveryHours: "Veuillez d'abord définir les heures de livraison !",
    visibleOptionGroupError: "Ce groupe d'options est requis. Au moins 1 article d'option doit être visible",
  },
  gender: {
    index: 'Genre',
    male: 'Masculin',
    female: 'Féminin',
    other: 'Autre',
  },
  displayModes: {
    default: 'Par défaut',
    launcher: 'Lanceur',
    smartPicker: 'Sélecteur intelligent',
    detailOverlay: 'Superposition de détail',
    detailDialog: 'Dialogue de détail',
    grid: 'Grille',
    pagedGrid: 'Grille paginée',
    circle: 'Cercle',
    topSeller: 'Meilleure vente',
    matrix: 'Matrice',
    banner: 'Bannière',
    drinkFlavor: 'Saveur de boisson',
    toggleButton: 'Bouton bascule',
    flavor: 'Saveur',
    checkbox: 'Case à cocher',
    radio: 'Bouton radio',
    code: 'Code',
  },
  displayIdentifiers: {
    extra: 'Extra',
    extra15: 'Extra 15',
    extra30: 'Extra 30',
    extraCheese15: 'Extra Fromage 15',
    extraCheese30: 'Extra Fromage 30',
    size: 'Taille',
    size15: 'Taille 15',
    size30: 'Taille 30',
    cheese: 'Fromage',
    kids: 'Enfants',
    salad: 'Salade',
    bread: 'Pain',
    cookie1: '1x Cookie',
    cookie3: '3x Cookie',
    cookie12: '12x Cookie',
    chips: 'Chips',
    sauce: 'Sauce',
    drink: 'Boisson',
    water: 'Eau',
    tea: 'Thé',
    hotBeverages: 'Boissons chaudes',
    menu: 'Menu',
    main: 'Principal',
    sub: 'Secondaire',
    wrap: 'Wrap',
    sides: 'Accompagnements',
    fullPrice: 'Prix complet',
    inverse: 'Inverse',
    code: 'Code',
  },
  venueSelector: {
    title: 'Sélectionner un restaurant',
    search: 'Veuillez sélectionner un restaurant',
    back: 'Retour aux restaurants',
  },
  currency: {
    eur: 'Euro',
    chf: 'Franc suisse',
    isk: 'Couronne islandaise',
    czk: 'Couronne tchèque',
    aed: 'Dirham des UAE',
    sek: 'Couronne suédoise',
    dkk: 'Couronne danoise',
    nok: 'Couronne norvégienne',
    gbp: 'Livre sterling',
    omr: 'Rial omanais',
  },
  routes: {
    smoothrPay: {
      index: 'Smoothr Pay',
      detail: 'Marchand',
      payments: 'Paiements',
      payouts: 'Versements',
    },
    venue: {
      index: 'Restaurant',
      create: 'Créer un restaurant',
      createSimple: 'Créer un restaurant',
      copyFoodcard: 'Copier la carte alimentaire',
      edit: 'Modifier le restaurant',
      panic: 'Paramètres de panique',
      editSimple: 'Modifier le restaurant',
      verify: 'Vérifier le restaurant',
      publish: 'Publier le restaurant',
      migrate: 'Migrer le restaurant',
      sync: 'Synchroniser le restaurant',
      copy: 'Copier le restaurant',
    },
    screensaver: {
      index: 'Écran de veille',
      create: 'Créer un écran de veille',
      edit: "Modifier l'écran de veille",
    },
    employeeNotification: {
      index: 'Notification employé',
      create: 'Créer une notification employé',
    },
    banner: {
      index: 'Bannières',
      create: 'Créer une bannière',
      edit: 'Modifier la bannière',
    },
    venueLabel: {
      index: 'Étiquette de restaurant',
      create: 'Créer une étiquette de restaurant',
      edit: "Modifier l'étiquette de restaurant",
    },
    sepa: {
      index: 'Paramètres SEPA',
    },
    productCombos: {
      index: 'Combinaisons de produits',
    },
    promo: {
      index: 'Codes promotionnels',
      create: 'Créer un code promotionnel',
      createTeedeli: 'Créer un code promotionnel Teedeli',
      edit: 'Modifier le code promotionnel',
      export: 'Exporter le code promotionnel',
      exportTeedeli: 'Exporter le code promotionnel Teedeli',
      disable: 'Désactiver les codes promotionnels',
      createMultiple: 'Créer plusieurs codes promotionnels',
    },
    cupCode: {
      index: 'Codes gobelet',
      create: 'Créer un code gobelet',
      edit: 'Modifier le code gobelet',
    },
    coupon: {
      index: 'Coupon (obsolète)',
      create: 'Créer un coupon',
      edit: 'Modifier le coupon',
      export: 'Exporter le coupon',
      disable: 'Désactiver le coupon',
      createMultiple: 'Créer plusieurs coupons',
    },
    maintenance: {
      index: 'Maintenance',
    },
    provision: {
      index: 'Commission',
    },
    inventory: {
      index: "Gérer l'inventaire",
      create: 'Créer un inventaire',
      edit: "Modifier l'inventaire",
    },
    payment: {
      index: 'Paiement',
    },
    home: {
      index: 'Accueil',
    },
    reporting: {
      index: 'Rapports',
    },
    register: {
      index: 'Informations franchise',
      venue: 'Inscrire des restaurants',
      success: 'Inscription réussie',
    },
    analytics: {
      index: 'Analytique',
    },
    sales: {
      index: 'Ventes',
    },
    salesOverview: {
      index: 'Aperçu des ventes',
    },
    receipt: {
      index: 'Reçus',
    },
    eposJobs: {
      index: 'Travaux EPOS',
    },
    sanifairLogs: {
      index: 'Journaux Sanifair',
    },
    automatedReports: {
      index: 'Rapports automatisés',
      create: 'Créer un rapport automatisé',
    },
    billing: {
      index: 'Facturation',
    },
    userExport: {
      index: "Exportation d'utilisateurs",
    },
    activityLogExport: {
      index: "Journaux d'activité",
    },
    lightspeed: {
      index: 'Lightspeed',
      success: 'Autorisation réussie',
      error: "Échec de l'autorisation",
    },
    statistics: {
      index: 'Statistiques',
    },
    error: {
      index: 'Erreur',
      notFound: '404 Page non trouvée',
      forbidden: '401 Interdit',
    },
    user: {
      index: 'Utilisateur',
      create: 'Créer un utilisateur',
      edit: "Modifier l'utilisateur",
      createSimple: 'Créer un utilisateur',
      editSimple: "Modifier l'utilisateur",
    },
    role: {
      index: 'Rôle',
      create: 'Créer un rôle',
      edit: 'Modifier le rôle',
    },
    customerGroupProprty: {
      index: 'Propriété du groupe de clients',
      create: 'Créer une propriété de groupe de clients',
      edit: 'Modifier la propriété du groupe de clients',
    },
    foodcard: {
      index: 'Importer la carte alimentaire',
    },
    printer: {
      index: 'Imprimante',
      edit: "Modifier l'imprimante",
    },
    tag: {
      index: 'Étiquette',
      create: 'Créer une étiquette',
      edit: "Modifier l'étiquette",
    },
    information: {
      index: 'Information',
      create: 'Créer une information',
      edit: "Modifier l'information",
    },
    constrain: {
      index: 'Groupe de commerce',
      create: 'Créer un groupe de commerce',
      edit: 'Modifier le groupe de commerce',
    },
    printGroups: {
      index: "Groupes d'impression",
      create: "Créer des groupes d'impression",
      edit: "Modifier les groupes d'impression",
    },
    dashboard: {
      index: 'Tableau de bord',
    },
    auditing: {
      index: 'Audit',
    },
    enrollments: {
      index: 'Inscriptions',
    },
    table: {
      index: 'Table',
      create: 'Créer une table',
      edit: 'Modifier la table',
    },
    category: {
      index: 'Catégorie',
      create: 'Créer une catégorie',
      edit: 'Modifier la catégorie',
    },
    subscriptionCategories: {
      index: "Catégorie d'abonnement",
      create: "Créer une catégorie d'abonnement",
      edit: "Modifier la catégorie d'abonnement",
    },
    subscription: {
      index: 'Abonnement',
      create: 'Créer un abonnement',
      edit: "Modifier l'abonnement",
    },
    membership: {
      index: 'Adhésion',
      create: 'Créer une adhésion',
      edit: "Modifier l'adhésion",
    },
    article: {
      index: 'Article',
      create: 'Créer un article',
      edit: "Modifier l'article",
      editSimple: "Modifier l'article",
    },
    articleManager: {
      index: "Gestionnaire d'articles",
    },
    recommendation: {
      index: 'Recommandation de panier',
      create: 'Créer une recommandation de panier',
      edit: 'Modifier la recommandation de panier',
    },
    option: {
      index: 'Option',
      create: 'Créer une option',
      edit: "Modifier l'option",
      editSimple: "Modifier l'option",
    },
    customer: {
      index: 'Client',
      create: 'Créer un client',
      edit: 'Modifier le client',
      import: 'Importer un client',
    },
    translation: {
      index: 'Traduction',
    },
    loyaltyPrograms: {
      index: 'Programmes de fidélité',
      create: 'Créer un programme de fidélité',
      edit: 'Modifier les programmes de fidélité',
    },
    sync: {
      index: 'Synchronisation',
      create: 'Créer une synchronisation',
      upsell: 'Créer une synchronisation des ventes incitatives',
    },
    aggregatorSyncs: {
      index: 'Synchronisations',
    },
    posSync: {
      index: 'POS Sync',
    },
    company: {
      index: 'Entreprises',
      create: 'Créer une entreprise',
      edit: "Modifier l'entreprise",
    },
    ui: {
      banner: {
        index: 'Bannières',
        create: 'Créer une bannière',
        edit: 'Modifier la bannière',
      },
      card: {
        index: 'Cartes',
        create: 'Créer une carte',
        edit: 'Modifier la carte',
      },
      slider: {
        index: 'Curseurs',
        create: 'Créer un curseur',
        edit: 'Modifier le curseur',
      },
    },
    campaign: {
      index: 'Campagnes',
      create: 'Créer une campagne',
      edit: 'Modifier la campagne',
    },
    releases: {
      index: 'Versions',
      create: 'Créer une version',
      edit: 'Modifier la version',
    },
    healthCheck: {
      index: 'Healthcheck',
      create: 'Créer un healthcheck',
      edit: 'Modifier le healthcheck',
    },
    upsells: {
      index: 'Ventes incitatives',
    },
    depositRule: {
      index: 'Deposit Rules',
      create: 'Create Deposit Rule',
      edit: 'Edit Deposit Rule',
    },
    forgotPassword: 'Mot de passe oublié',
    resetPassword: 'Réinitialiser le mot de passe',
  },
  weekdays: {
    monday: 'Lundi',
    mondayShort: 'Lun',
    tuesday: 'Mardi',
    tuesdayShort: 'Mar',
    wednesday: 'Mercredi',
    wednesdayShort: 'Mer',
    thursday: 'Jeudi',
    thursdayShort: 'Jeu',
    friday: 'Vendredi',
    fridayShort: 'Ven',
    saturday: 'Samedi',
    saturdayShort: 'Sam',
    sunday: 'Dimanche',
    sundayShort: 'Dim',
  },
  orderStatus: {
    none: 'Par défaut',
    created: 'Créé',
    in_preparation: 'En préparation',
    ready: 'Prêt',
    in_payment: 'En paiement',
    awaiting_confirmation: 'En attente de confirmation',
    done: 'Fait',
    failed: 'Échoué',
    validated: 'Validé',
    cancelled_by_waiter: 'Cancelled by Waiter',
    cancelled_by_customer: 'Cancelled by Customer',
  },
  checkoutIntegrationStatus: {
    sent: 'Envoyé',
    received: 'Reçu',
    verified: 'Vérifié',
    finalized: 'Finalisé',
    rejected: 'Rejeté',
    canceled: 'Annulé',
    postponed: 'Reporté',
  },
  stockMode: {
    none: 'Deactivated',
    toggle: 'Activated',
    disable_only: 'Only deactivate articles',
    enable_only: 'Only activate articles',
  },
  mainCategories: {
    dish: 'Plat',
    beverage: 'Boisson',
    other: 'Autre',
  },
  autoReset: {
    none: 'Aucun',
    morning: 'Matin',
    noon: 'Midi',
    evening: 'Soir',
    midnight: 'Minuit',
  },
  customerGroups: {
    default: 'par défaut',
    defaultInPreparation: 'par défaut_en préparation',
    defaultWebApp: 'par défaut_application web',
    subway: 'Subway',
    db: 'Deutsche Bahn',
    lunchroom: 'Lunchroom',
    weilands: 'Weilands',
    cinemaxx: 'Cinemaxx',
    fbf: 'Food By Friends',
    district: 'District',
    slush: 'Slush',
    kochloeffel: 'Kochlöffel',
    immergruen: 'Immergrün',
    myMonza: 'MyMonza',
    subwayFr: 'Subway France',
    subwayLu: 'Subway Luxembourg',
    subwayTerminal: 'Subway Terminal',
    aspasia: 'Aspasia',
    cotidiano: 'Cotidiano',
    bigburger: 'BigBurger',
    koos: 'KOOS',
    deanAndDavid: 'Dean and David',
    frittenwerk: 'Frittenwerk',
    purino: 'Purino',
    ottosBurger: 'Otto´s Burger',
    threeMensKebab: '3 Mens Kebab',
    perfectDay: 'Perfect Day',
    hausmanns: 'Hausmanns',
    doenerwerk: 'Dönerwerk',
    foodlounge: 'Foodlounge',
    mado: 'Mado',
    depot: 'Depot',
    nordsee: 'Nordsee',
    jamies: 'Jamies',
    burgerKing: 'Burger King',
    burgerKingD: 'Burger King D',
    atlantikFisch: 'Atlantik Fisch',
    moschmosch: 'Moschmosch',
    kamps: 'Kamps',
    coffeeFellows: 'Coffee Fellows',
    hofbrauhaus: 'Hofbrauhaus',
    saray: 'Saray',
    starbucks: 'Starbucks',
    dimatest: 'Dima Test',
    maloa: 'Maloa',
    werk5: 'Werk 5',
    epi: 'EPI',
    iamlove: 'IAMLOVE',
    beetsAndRoots: 'Beets and Roots',
    beetsAndRootsSecond: 'Beets and Roots 2',
    losteria: "L'Osteria",
    losteriaAt: "L'Osterie Austria",
    shiso: 'Shiso',
    snackElize: 'Snack Elize',
    tabilo: 'TUR RES',
    tabiloSim: 'TUR Simphony',
    turAbnahmeRes: 'TUR Abnahme RES',
    turAbnahmeSim: 'TUR Abnahme Sim',
    turAutohof: 'TUR Autohof',
    turAbnahmeAutohof: 'TUR Abnahme Autohof',
    turSegafredo: 'TUR Segafredo',
    effeGold: 'Effe & Gold',
    lacantine: 'La cantine',
    eam: 'Eam',
    naupaka: 'Naupaka',
    sportsbar: 'Sportsbar',
    cigkoftem: 'Cigkoftem',
    sushisupply: 'Sushi Supply',
    the_ash: 'The Ash',
    markthalle: 'Markthalle',
    sashimi: 'Sashimi',
    bonboncha: 'Bonboncha',
    hulala: 'Hulala',
    backwerk_schweiz: 'Backwerk Schweiz',
    backwerkCh: 'Backwerk CH',
    backfactory: 'Backfactory',
    teedeli: 'Teedeli',
    wohlfuhler: 'Wohlfuhler',
    asiaGourmet: 'Asia Gourmet',
    frittenwerkSecond: 'Frittenwerk 2',
    ricerepublic: 'RiceRepublic',
    goodbytz: 'Goodbytz',
    piratenBurger: 'Piraten Burger',
    tournesol: 'Tournesol',
    brezelKoenig: 'Brezelkönig',
    vincentVegan: 'Vincent Vegan',
    papais: 'Papais',
    theCup: 'The Cup',
    marseilleFoodMarket: 'Marseille Food Market',
    olearys: 'Olearys',
    iceland: 'Islande',
    tableDot: 'Table Dot',
    sevenByBat: 'Seven by BAT',
    breakBurger: 'Break Burger',
    wok: 'Wok',
    oakberry: 'Oakberry',
    trz: 'TRZ',
    monkeyBurger: 'Monkey Burger',
    pastaFee: 'Pasta Fee',
    potatoe: 'Potatoe',
    pibosa: 'Pibosa',
    pibose: 'Pibosa',
    shiangMing: 'Shiang Ming',
    antonAndAnni: 'Anton&Anni',
    kaisin: 'Kaisin',
    dunkin: 'Dunkin',
    sushiTomo: 'Sushi Tomo',
    spiga: 'SPIGA',
    rastpark: 'Euro Rastpark',
    ahoi: 'Ahoi',
    eatdoori: 'Eatdoori',
    burroBurro: 'Burro Burro',
    brammibalDonuts: 'Brammibal Donuts',
    milanoVice: 'Milano Vice',
    sspSliceIt: 'SSP Slice It',
    keladamsKebab: 'Keladams Kebab',
    autohof24: 'Autohof 24',
    reishauer: 'Reishauer',
    pastaLich: 'Pasta Lich',
    eintrachtFrankfurt: 'Eintracht Frankfurt',
    topgolf: 'Topgolf',
    klausKebab: 'Klaus Kebab',
    josefs: 'Josefs',
    burritoCompany: 'Burrito Company',
    zeroKebab: 'Zero Kebab',
    nhasCityChicken: 'Nhas City Chicken',
    mrSha: 'Mr. Sha',
    bollwerk: 'Bollwerk',
    wyniger: 'Wyniger',
    burgerVision: 'Burger Vision',
    picklBurger: 'Pickl Burger',
    maisonMatcha: 'Maison Matcha',
    enriqueTomas: 'Enrique Tomas',
    versaillesCastle: 'Château de Versailles',
    randys: 'Randys',
    saz: 'Saz',
    hawaiianPokeBowls: 'Hawaiian Poke Bowls',
    luca: 'Luca',
    olearysNordic: "O'Learys Nordic",
    trattoriaTavolare: 'Trattoria Tavolare',
    carlsbergSportsBar: 'Carlsberg Sports Bar',
    bistro: 'Bistro',
    jomfruin: 'Jomfruin',
    rabbagast: 'Rabbagast',
    craftNDraft: 'Craft n Draft',
    herfra: 'Herfra',
    cafeRitazza: 'Cafe Ritazza',
    heineken: 'Heineken',
    laBoutique: 'La Boutique',
    vaerbitt: 'Vaerbitt',
    originalChicken: 'Original Chicken',
    tigerstaden: 'Tigerstaden',
    bjornsBackyard: 'Bjorns Backyard',
    burgerKingCh: 'Burger King CH',
    gelatoBar: 'Gelato Bar',
    sspVincentVegan: 'SSP Vincent Vegan',
    elKiosko: 'El Kiosko',
    camden: 'Camden',
    pizzaHut: 'Pizza Hut',
    spareRib: 'Spare Rib',
    sodai: 'Sodai',
    lucullus: 'Lucullus',
    bonbird: 'Bonbird',
    sspPizzaHut: 'SSP Pizza Hut',
    elevenBar: '11 Bar',
    theKissingGates: 'The Kissing Gates',
    gambrinus: 'Gambrinus',
    tabernnus: 'Tabernnus',
    jimis: 'Jimis',
    hensslerAtHome: 'Henssler At Home',
    dailyPizza: 'Daily Pizza',
    hunterBar: 'Hunter Bar',
    mogaTee: 'Moga Tee',
    grauholz: 'Grauholz',
    figlmueller: 'Figlmüller',
    dominosSwitzerland: 'Dominos Pizza CH',
    wildChildCoffee: 'Wild Child Coffee',
    asFoodCompany: 'As Food Company',
    smashKoenig: 'Smash Koenig',
    schurter: 'Schurter',
    dirtyPatty: 'Dirty Patty',
    captainHook: 'Captain Hook',
    ingerslevs: 'Ingerslevs',
    thaqiCafeNuernberg: 'Thaqi Cafe Nürnberg',
    aramarkAsianBistrotConcept: 'Aramark Asian Bistrot Concept',
    theBab: 'The Bab',
    locoChicken: 'Loco Chicken',
    eatery77: 'Eatery 77',
    beshle: 'Beshle',
    feasty: 'Feasty',
    kantine11: 'Kantine 11',
    foodBrother: 'Food Brother',
    pastalich: 'Pastalich',
    zagros: 'Zagros',
    montys: 'Montys',
    barinoRestaurant: 'Barino Restaurant',
    upstairsBar: 'Upstairs & Bar',
    eateryGarden: 'Eatery Garden',
    barBistro: 'Bar&Bistro',
    upperCrust: 'Upper Crust',
    oakBarrel: 'Oak Barrel',
    spizzaPizza: 'Spizza Pizza',
    kerb: 'Kerb',
    derDonerKebabhaus: 'Der Doner Kebabhaus',
    takkeh: 'Takkeh',
    acayaKoblenz: 'Acaya Koblenz',
    forzanapoliDe: 'Forzanapoli DE',
    macai: 'Macai',
    donCarne: 'Don Carne',
    basicKitchenMarburg: 'Basic Kitchen Marburg',
  },
  deliverableOrderTypes: {
    foodspot: 'Foodspot',
    delivery: 'Livraison',
  },
  error: {
    notFound: "Désolé, la page n'a pas pu être trouvée.",
    forbidden: 'Interdit.',
    goHome: 'Retour au début',
    forbiddenText: "Non autorisé. Vous n'êtes pas autorisé à voir cette page.",
    notFoundText: 'La page que vous recherchez est introuvable.',
  },
  foodcard: {
    index: 'Gérer la carte alimentaire',
    export_csv: 'Exporter la carte alimentaire (*.csv)',
    export_csv_de: 'Exporter la carte alimentaire DE (*.csv)',
    import: 'Importer la carte alimentaire',
    importCvs: 'Importer la carte alimentaire (*.csv)',
    importNutritionCsv: 'Importer les valeurs nutritionnelles (*.csv)',
    export_xlsx_de: 'Exporter la carte alimentaire DE (*.xlsx)',
    importCvsWithArticleInfo: 'Importer les informations des articles (*.csv)',
  },
  home: {
    index: 'Accueil',
    welcome: 'Bienvenue !',
  },
  tag: {
    index: 'Gérer les étiquettes',
    overview: "Vue d'ensemble",
    add: 'Ajouter une étiquette',
    empty:
      "Il semble que vous n'ayez pas encore ajouté d'étiquettes. Créez votre première étiquette pour les attribuer à vos articles et options.",
    form: {
      name: 'Nom',
      identifier: 'Identifiant',
      sort: 'Trier',
      recommendationTag: 'Étiquette de recommandation',
    },
    table: {
      name: 'Nom',
      identifier: 'Identifiant',
      sort: 'Trier',
      recommendationTag: 'Étiquette de recommandation',
    },
  },
  depositRule: {
    index: 'Gérer les Deposit Rules',
    overview: "Vue d'ensemble",
    add: 'Ajouter une Deposit Rule',
    empty:
      "Il semble que vous n'ayez pas encore ajouté de Deposit Rules. Créez votre première Deposit Rule pour les attribuer à vos articles.",
    form: {
      priority: 'Prioirity',
      deposit: 'Deposit',
      startedAt: 'From',
      endedAt: 'To',
    },
    table: {
      priority: 'Prioirity',
      deposit: 'Deposit',
      startedAt: 'From',
      endedAt: 'To',
    },
  },
  information: {
    index: 'Gérer les informations',
    overview: "Vue d'ensemble",
    add: 'Ajouter une information',
    edit: "Modifier l'information",
    addAction: 'Ajouter une action',
    removeAction: "Supprimer l'action",
    actions: 'Actions',
    empty:
      "Il semble que vous n'ayez pas encore ajouté d'informations. Créez votre première information pour informer les clients des événements et promotions à venir.",
    actionTypes: {
      primary: 'Principal',
      secondary: 'Secondaire',
      cancel: 'Annuler',
    },
    form: {
      image: 'Image',
      title: 'Titre',
      from: 'De',
      to: 'À',
      description: 'Description',
      url: 'URL',
      action: 'Action',
      actionType: "Type d'action",
      actionValue: "Valeur de l'action",
      actionHtmlContent: 'Contenu HTML',
      actionName: "Nom de l'action",
    },
    table: {
      title: 'Titre',
      description: 'Description',
      from: 'De',
      to: 'À',
      url: 'URL',
    },
  },
  role: {
    index: 'Gérer les rôles',
    overview: "Vue d'ensemble",
    create: 'Créer un rôle',
    edit: 'Modifier le rôle',
    copy: 'Copier le rôle',
    empty:
      "Il semble que vous n'ayez pas encore créé de rôles. Créez votre premier rôle pour donner aux utilisateurs un accès granulaire.",
    help: 'Attention ! Ne modifiez un rôle que si vous êtes absolument sûr de ce que vous faites. Notez également que les rôles système ne peuvent pas être modifiés.',
    add: 'Ajouter un rôle',
    table: {
      name: 'Nom',
      slug: 'Slug',
      isSystem: 'Rôle système',
      permissions: 'Permissions',
    },
    form: {
      name: 'Nom',
      slug: 'Slug (identifiant unique)',
      isSystem: 'Rôle système (si actif, le rôle ne peut pas être modifié.)',
      permissions: 'Permissions',
    },
    notification: {
      roleCopyStarted:
        'Le processus de copie du rôle a commencé. Vous serez redirigé vers la page de création de rôle avec des données préremplies. Veuillez appliquer les modifications si nécessaire et cliquer sur Enregistrer.',
      roleCopyFailed: 'Le processus de copie du rôle a échoué. Veuillez réessayer.',
    },
  },
  customerGroupProprty: {
    index: 'Gérer la propriété du groupe de clients',
    overview: "Vue d'ensemble",
    create: 'Créer une propriété de groupe de clients',
    edit: 'Modifier la propriété du groupe de clients',
    add: 'Ajouter une propriété de groupe de clients',
    importTemplate: 'Importer un modèle de facture client',
    table: {
      name: 'Nom',
      template: 'Modèle de facture',
      defaultOrderStatus: 'Statut de commande par défaut',
      initialOrderStatusStandard: 'Statut de commande initial standard',
      initialOrderStatusTerminal: 'Statut de commande initial terminal',
    },
    form: {
      customerGroupName: 'Nom',
      getDefaultOrderStatus: 'Statut de commande par défaut',
      getInitialOrderStatusStandard: 'Statut de commande initial standard',
      getInitialOrderStatusTerminal: 'Statut de commande initial terminal',
      getInitialOrderStatusVirtual: 'Statut de commande initial virtuel',
    },
  },
  venueLabel: {
    index: 'Gérer les étiquettes de restaurant',
    overview: "Vue d'ensemble",
    create: 'Créer une étiquette de restaurant',
    edit: "Modifier l'étiquette de restaurant",
    empty: "Il semble que vous n'ayez pas encore créé d'étiquettes de restaurant.",
    add: 'Ajouter une étiquette',
    table: {
      name: 'Nom',
      slug: 'Slug',
      venues: 'Restaurants',
    },
    form: {
      name: 'Nom',
      image: 'Image',
      slug: 'Slug (identifiant unique)',
      venues: 'Restaurants',
      visibleTo: 'Visible pour les restaurants',
    },
  },
  recommendation: {
    index: 'Recommandation de panier',
    create: 'Créer une recommandation de panier',
    edit: 'Modifier la recommandation de panier',
    overview: "Vue d'ensemble",
    score: 'Score',
    scoreMatrix: 'Matrice de score',
    scoreMatrixNotFound: 'Matrice de score non trouvée',
    best: 'Meilleur',
    worst: 'Pire',
  },
  user: {
    index: 'Gérer les utilisateurs',
    overview: "Vue d'ensemble",
    create: 'Créer un utilisateur',
    adminCreateWarning: 'Attention : vous essayez de créer un utilisateur avec le rôle administrateur.',
    adminCreateConfirm: 'Êtes-vous vraiment sûr de vouloir créer un utilisateur administrateur ?',
    changePassword: 'Changer le mot de passe',
    help: 'Attention ! Ne modifiez un utilisateur que si vous êtes absolument sûr de ce que vous faites. Sinon, un utilisateur pourrait ne pas pouvoir se connecter.',
    edit: "Modifier l'utilisateur",
    add: 'Ajouter un utilisateur',
    table: {
      name: 'Nom',
      email: 'E-mail',
      code: 'Code',
      venues: 'Restaurants',
      role: 'Rôle',
    },
    form: {
      name: 'Nom',
      customerGroup: 'Groupe de clients',
      linkedCustomerGroup: 'Groupe de clients lié',
      email: 'E-mail',
      password: 'Mot de passe',
      passwordConfirmation: 'Confirmation du mot de passe',
      venues: 'Restaurants',
      venueLabels: 'Étiquettes de restaurant',
      role: 'Rôle',
    },
  },
  printer: {
    index: 'Gérer les imprimantes',
    overview: "Vue d'ensemble",
    edit: "Modifier l'imprimante",
    customerGroup: 'Groupe de clients',
    empty: "Il semble qu'il n'y ait pas encore d'imprimantes.",
    table: {
      name: 'Nom',
      articleCount: "Nombre d'articles",
      venue: 'Restaurant',
      startedAt: 'Démarré à',
      activated: 'Activé',
      lastSignal: 'Dernier signal',
      latestActivity: 'Dernière activité',
      restart: 'Redémarrer',
      restartInProgress: 'Redémarrage en cours...',
      order: 'Commande',
    },
    form: {
      articles: 'Articles',
      name: 'Nom',
    },
  },
  customer: {
    index: 'Gérer les clients',
    overview: "Vue d'ensemble",
    edit: 'Modifier le client',
    create: 'Créer un client',
    add: 'Ajouter un client',
    import: 'Importer un client',
    empty: "Il semble que vous n'ayez pas encore ajouté de clients. Créez votre premier client.",
    table: {
      userUid: 'UID utilisateur',
      name: 'Nom',
      email: 'E-mail',
      qr: 'Code QR',
    },
    form: {
      email: 'E-mail',
      gender: 'Genre',
      name: 'Nom complet',
      city: 'Ville',
      street: 'Rue',
      number: 'Numéro',
      postalCode: 'Code postal',
    },
  },
  constrain: {
    index: 'Gérer les groupes de commerce',
    overview: "Vue d'ensemble",
    add: 'Ajouter un groupe de commerce',
    empty:
      "Il semble que vous n'ayez pas encore ajouté de groupes de commerce. Créez votre premier groupe de commerce pour les attribuer à vos articles.",
    form: {
      name: 'Nom',
      identifier: 'Identifiant',
      active: 'Actif',
    },
    table: {
      name: 'Nom',
      identifier: 'Identifiant',
      active: 'Actif',
    },
  },
  printGroups: {
    index: "Gérer les groupes d'impression",
    overview: "Vue d'ensemble",
    add: "Ajouter des groupes d'impression",
    empty:
      "Il semble que vous n'ayez pas encore ajouté de groupes d'impression. Créez votre premier groupe d'impression pour les attribuer à vos articles.",
    form: {
      name: 'Nom',
      identifier: 'Identifiant',
      active: 'Actif',
    },
    table: {
      name: 'Nom',
      identifier: 'Identifiant',
      active: 'Actif',
    },
  },
  languages: {
    de: 'Allemand',
    en: 'Anglais',
    fr: 'Français',
    nl: 'Néerlandais',
    it: 'Italien',
    pl: 'Polonais',
    es: 'Espagnol',
    tr: 'Turc',
    zh: 'Chinois',
    ru: 'Russe',
    da: 'Danois',
    ja: 'Japonais',
    is: 'Islandais',
    pt: 'Portugais',
    cz: 'Tchèque (NE PAS UTILISER)',
    cs: 'Tchèque',
    ar: 'Arabe',
    el: 'Grec',
    ko: 'Coréen',
    th: 'Thaï',
    vi: 'Vietnamien',
    hi: 'Hindi',
    ur: 'Ourdou',
    tl: 'Tagalog',
    id: 'Indonésien',
    no: 'Norvégien',
    sv: 'Suédois',
    lt: 'Lituanien',
    fi: 'Finnois',
  },
  legalForms: {
    ag: 'AG',
    gmbh: 'GmbH',
    ltd: 'UG',
    kg: 'KG',
    pe: 'Entreprise individuelle',
    other: 'Autre',
    sa: 'SA',
    sarl: 'SARL',
    eurl: 'EURL',
    sas: 'SAS',
    autres: 'AUTRES',
    se: 'SE',
    seCoKg: 'SE & Co. KG',
  },
  periods: {
    daily: 'Quotidien',
    weekly: 'Hebdomadaire',
    monthly: 'Mensuel',
    never: 'Jamais',
  },
  locTypes: {
    bar: 'Bar',
    club: 'Club',
    restaurant: 'Restaurant',
    db: 'Deutsche Bahn',
    cinema: 'Cinéma',
    other: 'Autre',
  },
  paymentTypes: {
    cc: 'Carte de crédit',
    pp: 'PayPal',
    sepa: 'SEPA',
    sb: 'Klarna',
    paypal: 'PayPal',
    cash: 'Espèces',
    credit_card: 'Carte de crédit',
    balance: 'Solde',
    pos: 'POS',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    sofortbanking: 'Klarna',
    wallee: 'Wallee',
    postfinance: 'PostFinance',
    postfinance_card: 'PostFinance Card',
    reka: 'Reka',
    twint: 'Twint',
    luncheck: 'Luncheck',
    boncard: 'Boncard',
    alipay: 'Alipay',
    wechat: 'WeChat Pay',
    worldline: 'Worldline',
    worldline_raw: 'Worldline (brut)',
    tac: 'TAC',
    ccv: 'CCV',
    zero_payment: 'Paiement zéro',
    wolt: 'Wolt',
    ec: 'EC',
    girocard: 'Girocard',
    mastercard: 'Mastercard',
    amex: 'American Express',
    visa: 'Visa',
    visa_e: 'Visa Electron',
    vpay: 'V PAY',
    jcb: 'JCB',
    maestro: 'Maestro',
    other: 'Autre',
    vr_sepa: 'VR SEPA',
    bank_transfer: 'Virement bancaire',
    diners: 'Diners Club',
    discover: 'Discover',
    subsidy: 'Subvention',
    piggy_gift_card: 'Carte cadeau Piggy',
    piggy_prepaid_balance: 'Solde prépayé Piggy',
    como_gift_card: 'Carte cadeau Como',
    miles_and_more: 'Miles & More',
    kost_card: 'Carte KOST',
    worldline_mobile_apple_pay: 'Worldline Mobile Apple Pay',
    worldline_mobile_credit_card: 'Worldline Mobile Carte de crédit',
    worldline_mobile_google_pay: 'Worldline Mobile Google Pay',
    worldline_apple_pay: 'Worldline Apple Pay',
    worldline_credit_card: 'Worldline Carte de crédit',
    worldline_google_pay: 'Worldline Google Pay',
    ideal: 'iDEAL',
    meal_voucher_fr: 'Ticket restaurant (FR)',
    bon_bon_gift_card: 'Carte cadeau Bon Bon',
    deliveroo: 'Deliveroo',
    swish: 'Swish',
    vipps: 'Vipps',
    mobile_pay: 'Mobile Pay',
    dankort: 'Dankort',
    maxxvend: 'MAXXvend',
  },
  nav: {
    smoothrPay: 'Smoothr Pay',
    smoothrPayMerchants: 'Marchands',
    smoothrPayPayments: 'Paiements',
    smoothrPayPayouts: 'Versements',
    smoothrPayReports: 'Relevés',
    dashboard: 'Tableau de bord',
    auditing: 'Audit',
    enrollments: 'Inscriptions',
    foodcard: 'Carte alimentaire',
    customer: 'Clients',
    screensaver: 'Écran de veille',
    venue: 'Restaurants',
    venueLabel: 'Étiquettes de restaurant',
    productCombos: 'Combinaisons de produits',
    payment: 'Paiements',
    user: 'Utilisateur',
    table: 'Tables',
    tag: 'Étiquettes',
    information: 'Information',
    sales: 'Ventes',
    salesOverview: 'Aperçu des ventes',
    printer: 'Imprimante',
    translation: 'Traduction',
    tradegroup: 'Groupes de commerce',
    printGroups: "Groupes d'impression",
    provision: 'Commission',
    inventory: 'Inventaire',
    statistic: 'Statistiques',
    analytic: 'Analytique',
    receipts: 'Reçus',
    billing: 'Facturation',
    userExport: "Exportation d'utilisateurs",
    selectVenue: 'Sélectionner un restaurant',
    category: 'Catégories',
    subscriptionCategories: "Catégorie d'abonnement",
    subscription: 'Abonnement',
    membership: "Niveau d'adhésion",
    article: 'Articles',
    articleManager: 'Visibilité des articles et options',
    recommendations: 'Recommandations',
    option: 'Options',
    reporting: 'Rapports',
    import: 'Importation',
    role: 'Rôle',
    sepa: 'SEPA',
    maintenance: 'Maintenance',
    promo: 'Codes promotionnels',
    banner: 'Bannières',
    tips: 'Pourboires',
    eposJobs: 'Travaux EPOS',
    automatedReport: 'Rapports automatisés',
    coupon: 'Coupon (obsolète)',
    employeeNotification: 'Notification employé',
    loyaltyPrograms: 'Programme de fidélité',
    comoManagedGifts: 'Cadeaux Como gérés',
    seasonPass: 'Passe de saison',
    automatedReports: 'Rapports automatisés',
    customerGroupProprty: 'Groupe de clients',
    sanifairLogs: 'Journaux Sanifair',
    cupCode: 'Codes gobelet',
    activityLogExport: "Exportation des journaux d'activité",
    sync: 'Synchronisation',
    aggregatorSyncs: "Synchronisation d'agrégation",
    posSync: 'POS Sync',
    company: 'Entreprises',
    promocodesAndLoyalty: 'Fidélité',
    customerInfo: 'Informations client',
    other: 'Autre',
    finances: 'Finances',
    analytics: 'Analytique',
    syncAndLogs: 'Synchronisation et journaux',
    uiComponents: "Composants d'interface",
    uiSlides: 'Diapositives',
    uiSlider: 'Curseur',
    uiCard: 'Carte',
    uiBanner: 'Bannière',
    campaigns: 'Campagnes',
    releases: 'Versions',
    upsell: 'Ventes incitatives',
    depositRule: 'Deposit Rules',
    healthCheck: 'Healthcheck',
  },
  auth: {
    logout: 'Déconnexion',
    login: 'Connexion',
    forgotPassword: 'Mot de passe oublié',
    forgotPasswordHint: 'Veuillez saisir votre e-mail et cliquer sur réinitialiser le mot de passe.',
    resetPassword: 'Réinitialiser le mot de passe',
    reset: 'Réinitialiser le mot de passe',
    security: 'Sécurité du compte',
    form: {
      password: 'Mot de passe',
      passwordHint:
        'Le mot de passe doit contenir au moins 8 caractères, 1 lettre majuscule et 1 chiffre ou caractère spécial.',
      passwordConfirmation: 'Confirmation du mot de passe',
      email: 'E-mail',
      otp: 'Code à usage unique',
    },
    mfaModal: {
      title: 'Approbation requise',
      description: 'Saisissez votre code MFA',
    },
    accountSecurity: {
      title: 'Sécurité du compte',
      mfa: {
        title: 'Authentification multifacteur (MFA)',
        description:
          "L'authentification multifacteur ajoute une couche de sécurité supplémentaire à votre compte en exigeant plus que le mot de passe pour la connexion et les fonctions critiques.",
        setup: "Configurer l'application d'authentification",
        scan: "Scannez le code QR avec votre application d'authentification.",
        enterCode: "Après avoir scanné le code QR, l'application vous affichera un code. Saisissez ce code ci-dessous.",
        enterCodeShort: 'Saisissez votre code MFA :',
        backupCodesTitle: 'Codes de sauvegarde',
        backupCodesExplanation:
          "Si l'authentification multifacteur est active et que vous perdez votre appareil, vous aurez besoin des codes de sauvegarde pour accéder à votre compte Lemin.",
        backupCodesDanger:
          "Sans codes de sauvegarde, vous devrez contacter notre support et fournir une preuve appropriée pour que votre compte Lemin puisse être réactivé. <br/><br/> Nous vous recommandons de télécharger ou de copier les codes de sauvegarde et de les conserver en lieu sûr. Chaque code de sauvegarde n'est valable qu'une seule fois et sera supprimé après utilisation.",
        copy: 'Copier',
        download: 'Télécharger',
        print: 'Imprimer',
        status: 'Statut',
        active: 'Actif',
        notActive: 'Non actif',
        deactivate: 'Désactiver',
        showBackupCodes: 'Afficher les codes de sauvegarde',
        regenerateBackupCodes: 'Régénérer les codes de sauvegarde',
        deactivateMFATitle: "Désactiver l'authentification multifacteur",
        deactivateMFADanger:
          "Pour utiliser à nouveau l'authentification multifacteur, vous devez la configurer à nouveau. Les codes de sauvegarde existants seront supprimés après la désactivation. <br/><br/>Êtes-vous sûr de vouloir continuer ?",
      },
    },
    notification: {
      forgotPassword:
        'Si nous avons trouvé votre e-mail dans notre système, nous vous enverrons un e-mail avec un lien pour réinitialiser votre mot de passe',
      resetPassword: 'Votre mot de passe a été réinitialisé.',
      forbidden: "Vous n'êtes pas autorisé à voir cette page.",
      login: 'Vous vous êtes connecté avec succès.',
      logout: 'Vous vous êtes déconnecté avec succès.',
      resetPasswordError: 'Soit votre jeton est introuvable, soit il a expiré.',
      invalidMFACode: 'Le code MFA est invalide.',
    },
  },
  maintenance: {
    index: 'Maintenance',
    status: 'État de la maintenance',
    enable: 'Activer la maintenance',
    disable: 'Désactiver la maintenance',
    enabled:
      'Le système fonctionne actuellement en mode maintenance. Certains services peuvent ne pas être disponibles.',
    disabled: 'Tous les systèmes fonctionnent correctement.',
  },
  register: {
    index: 'Inscription',
    account: 'Compte',
    register: "S'inscrire",
    success: 'Inscription réussie',
    addVenue: 'Ajouter un restaurant',
    removeVenue: 'Supprimer le restaurant',
    venue: 'Créer des restaurants',
    documentInfo:
      'Veuillez remplir les données suivantes pour générer votre empreinte, vos conditions générales et votre politique de confidentialité pour votre boutique en ligne. Ces documents sont nécessaires.',
    successText: 'Votre inscription a réussi. Nous vous informerons par e-mail lorsque vos restaurants seront créés.',
    location: 'Détails du lieu',
    invoiceReceiver: 'Destinataire de la facture',
    dialog: {
      venue: 'Souhaitez-vous créer un restaurant ? Si vous cliquez sur non, vous pourrez toujours le faire plus tard.',
    },
    form: {
      venue: 'Restaurant',
      name: 'Nom complet',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      phone: 'Téléphone',
      email: 'E-mail',
      password: 'Mot de passe (min. 6)',
      passwordHint:
        'Le mot de passe doit contenir au moins 8 caractères, 1 lettre majuscule et 1 chiffre ou caractère spécial.',
      passwordConfirmation: 'Confirmation du mot de passe (min. 6)',
      privacy: "J'accepte les règlements de protection des données",
      privacyLink: 'Règlements de protection des données',
    },
    notification: {
      venue:
        'Votre nouveau restaurant sera ajouté dans quelques minutes. Veuillez vous déconnecter et vous connecter dans 3 minutes pour voir et modifier votre nouveau restaurant.',
    },
  },
  article: {
    index: 'Gérer les articles',
    create: 'Créer un nouvel article',
    edit: "Modifier l'article",
    copy: "Copier l'article",
    testFoodcard: 'Tester la carte alimentaire',
    add: 'Ajouter un article',
    availability: 'Disponibilité',
    overview: "Vue d'ensemble",
    selectArticle: "Sélectionner l'article",
    selectCategory: 'Veuillez sélectionner une catégorie',
    general: 'Général',
    prices: 'Prix',
    visibility: 'Visible',
    meta: 'Méta',
    measurement: 'Mesure',
    media: 'Média',
    options: 'Options',
    displayPrices: 'Afficher les prix',
    mappings: "Correspondances d'articles",
    requirements: 'Exigences des articles',
    nutritions: 'Valeurs nutritionnelles des articles',
    defaults: 'Par défaut des articles',
    recommendations: "Recommandations d'articles",
    depArticles: 'Articles',
    availableHours: 'Heures disponibles',
    addGroupDependency: 'Ajouter une dépendance',
    addGroupReverseDependency: 'Ajouter des dépendances inverses',
    addMappingArticle: 'Ajouter un article de correspondance',
    addDepArticles: 'Ajouter des articles dépendants',
    addReverseDepArticles: 'Ajouter des articles dépendants inverses',
    dependencies: 'Dépendances',
    reverseDependencies: 'Dépendances inverses',
    addDefault: 'Ajouter une valeur par défaut',
    split: 'Diviser',
    standardPrices: 'Prix standard',
    preorderPrices: 'Prix de précommande',
    terminalPrices: 'Prix terminal',
    standardAvailability: 'Disponibilité standard',
    terminalAvailability: 'Disponibilité terminal',
    preorderAvailability: 'Disponibilité de précommande',
    priceLockByType: 'Verrouillage des prix par type de commande (le verrouillage général des prix a la priorité)',
    webAvailability: 'Disponibilité web',
    cateringAvailability: 'Disponibilité traiteur',
    noVisibleArticlesNotice: "Désolé ! Ce groupe d'options n'a pas d'articles visibles.",
    addRecommendation: 'Ajouter une recommandation',
    price: 'Prix',
    priceLowToHigh: 'Du plus bas au plus haut',
    priceHighToLow: 'Du plus haut au plus bas',
    visible: 'Visible',
    hide: 'Masquer',
    fontColor: 'Couleur de la police',
    styleOption: 'Options de style',
    borderColor: 'Couleur de la bordure',
    backgroundColor: "Couleur d'arrière-plan",
    style: 'Styles',
    loyaltyOptions: 'Options de fidélité',
    openingHours: "Heures d'ouverture",
    manufacturer: 'Fabricant',
    ingredients: 'Ingrédients',
    dimension: 'Dimensions',
    weightDetails: 'Détails du poids',
    seeOriginal: "Voir l'article original",
    displayIdentifiersOfOptions: 'Afficher les identifiants des options',
    tagsOfArticle: "Étiquettes de l'article",
    helloTess: {
      hellotessApiBaseUrl: "URL de l'API helloTESS !",
      hellotessApiKey: 'Clé API helloTESS !',
      success: 'La carte alimentaire a été importée',
    },
    gastrofix: {
      gastrofixBusinessUnit: 'Unité commerciale',
      gastrofixApiKey: 'Clé API Gastrofix',
      gastrofixImportLanguage: 'Langue de la carte alimentaire',
      success: 'La carte alimentaire a été importée',
    },
    simphony: {
      orgShortName: "Identifiant de l'organisation/Nom court",
      locRef: 'Identifiant du lieu',
      rvcRef: 'Identifiant du centre de revenus',
      serviceUrl: 'URL du service',
      importLanguage: 'Langue de la carte alimentaire',
      success: 'La carte alimentaire a été importée',
    },
    deliverect: {
      account: 'ID du compte client Deliverect',
      menu: 'ID du menu',
      importLanguage: 'Langue de la carte alimentaire',
      success: 'La carte alimentaire a été importée',
    },
    generalImport: {
      checkoutIntegration: 'Carte alimentaire',
    },
    tabs: {
      general: 'Général',
      media: 'Média',
      meta: 'Méta',
      options: 'Options',
      prices: 'Prix',
      displayPrices: 'Afficher les prix',
      availableHours: 'Heures disponibles',
      availability: 'Disponibilité',
      allergens_and_additives: 'Allergènes et additifs',
      nutritions: 'Valeurs nutritionnelles',
      features: 'Caractéristiques',
      style: 'Styles',
      wolt: 'Wolt',
      uberEats: 'Uber Eats',
      jet: 'Jet',
      deliveroo: 'Deliveroo',
      visibility: 'Visibilité',
    },
    table: {
      name: 'Nom',
      stock: 'Stock',
      price: 'Prix',
      active: 'Actif',
      assets: 'Image',
      internalNote: 'Note interne',
      internalName: 'Nom interne',
      category: 'Catégorie',
      isControlArticle: 'Article de contrôle',
      availableHours: 'Heures disponibles',
      categoryAvailableHours: 'Heures disponibles de la catégorie',
      icon: 'Icône',
      banner: 'Bannière',
      description: 'Description',
      number: 'Numéro',
      sortOrder: 'Trier',
      gtin: 'GTIN',
      visible: 'Visible',
      rowsPerPage: 'Lignes par page',
      externalId: 'ID externe',
      preorderDeliveryPrice: 'Prix de livraison en précommande',
      preorderTakeAwayPrice: 'Prix à emporter en précommande',
      terminalTakeAwayPrice: 'Prix à emporter terminal',
      terminalInsidePrice: 'Prix sur place terminal',
      tags: 'Étiquettes',
      taxTakeaway: 'Taxe à emporter',
      taxInside: 'Taxe sur place',
      uber: 'Uber Eats',
      wolt: 'Wolt',
      jet: 'Jet',
      uberEatsTakeawayEnabled: 'Uber Eats à emporter disponible',
      uberEatsDeliveryEnabled: 'Uber Eats livraison disponible',
      woltVisibility: 'Visibilité Wolt',
      woltActive: 'Wolt actif',
      jetTakeawayEnabled: 'Jet à emporter disponible',
      jetDeliveryEnabled: 'Jet livraison disponible',
    },
    copyDialog: {
      sourceCategory: 'Catégorie source',
      targetCategory: 'Catégorie cible',
      articles: 'Articles',
      venue: 'Sélectionner un restaurant',
      success: "L'article(s) a été copié",
    },
    testFoodcardModal: {
      chunkSize: "Nombre d'articles par commande",
      success: 'Le test de la carte alimentaire a été démarré avec succès.',
      error: "Le test de la carte alimentaire n'a pas pu être démarré.",
    },
    form: {
      name: 'Nom',
      internalName: 'Nom interne',
      description: 'Description',
      price: 'Prix',
      prices: 'Prix',
      type: 'Type',
      value: 'Valeur',
      emailDomain: 'Domaine e-mail',
      bannerVideo: 'Vidéo',
      kostPrice: 'Prix KOST',
      maxxvendPrice: 'Prix MAXXvend',
      dndCompany: 'Entreprise DND',
      min: 'Min.',
      max: 'Max.',
      standardPrice: 'Prix standard',
      insidePrice: 'Prix sur place',
      enabledInFoodcard: "Actif (si non actif, l'élément ne sera pas ajouté au menu Wolt)",
      deliveryPrice: 'Prix de livraison',
      takeAwayPrice: 'Prix à emporter',
      replacesMainArticle: "Remplace l'article principal",
      gtin: "GTIN (Numéro d'identification global du commerce)",
      externalId: 'ID externe',
      internalNote: 'Note interne',
      preparationTime: 'Temps de préparation (en minutes)',
      plu: 'PLU',
      standardAvailability: 'Disponible',
      insideAvailability: 'Disponible sur place',
      takeAwayAvailability: 'Disponible à emporter',
      deliveryAvailability: 'Disponible en livraison',
      webAvailability: 'Disponible',
      stock: 'Stock',
      image: 'Image',
      banner: 'Bannière',
      icon: 'Icône',
      active: 'Actif',
      tags: 'Étiquettes',
      group: "Groupe d'options",
      mainRecommendations: 'Recommandations principales',
      priceIsLocked: 'Prix verrouillé (tous)',
      isNoticeable: 'Remarquable',
      isControlArticle: 'Article de contrôle',
      shortDescription: 'Description courte',
      articles: 'Articles',
      article: 'Article',
      visible: 'Visible',
      printerSort: "Tri d'imprimante",
      quantity: 'Quantité',
      constrains: 'Groupes de commerce',
      printGroups: "Groupes d'impression",
      unit: 'Unité',
      amount: 'Montant',
      rateable: 'Évaluable',
      taxInside: 'Taxe sur place',
      taxTakeaway: 'Taxe à emporter',
      takeaway: 'À emporter',
      delivery: 'Livraison',
      inside: 'Sur place',
      displayPrice: 'Afficher le prix',
      referencePrice: 'Prix de référence',
      referencePriceHint:
        'Prix de vente habituel de l\'article. Pour les articles en promotion, le champ "Prix" correspond au prix promotionnel ; indiquez ici le prix normal afin que le prix initial et la réduction soient correctement affichés.',
      isPrintable: 'Imprimable',
      isRateable: 'Évaluable',
      info: 'Info',
      sort: 'Trier',
      mappedArticle: 'Article correspondant',
      code: 'Code',
      category: 'Catégorie',
      number: 'Numéro',
      deposit: 'Dépôt',
      fsk: 'FSK',
      alcoholPercentage: 'Alcool (en pourcentage)',
      caffeineMg: 'Caféine (mg)',
      main: 'Article principal',
      kcal: 'Kcal',
      options: 'Options',
      optionGroup: "Groupe d'options",
      newName: 'Nouveau nom',
      availableDateStart: 'Date de début de disponibilité',
      availableDateEnd: 'Date de fin de disponibilité',
      maxItemsPerCart: "Max. d'articles par panier",
      articleRelativeBrand: 'Marque',
      loyaltyId: 'ID de fidélité',
      isPiggyLoyalty: 'Est Piggy Loyalty',
      redeemableAtCheckoutOnly: 'Échangeable',
      piggyPointsNeeded: 'Points Piggy nécessaires (obsolète)',
      piggyRewardUuid: 'Uuid de récompense Piggy',
      requiredLoyaltyPoints: "Points de fidélité requis pour l'échange",
      address: 'Adresse',
      country: 'Pays',
      visibility: 'Visibilité',
      company: 'Entreprise',
      height: 'Hauteur (cm)',
      width: 'Largeur (cm)',
      length: 'Longueur (cm)',
      weight: 'Poids (g)',
      foodInstructions: 'Instructions alimentaires',
      storageInstructions: 'Instructions de stockage',
      providerImage: 'Image',
      priceLockByType: {
        standard: 'Standard',
        terminal: 'Terminal',
        preorder: 'Précommande',
        inside: 'Prix verrouillé pour sur place',
        takeAway: 'Prix verrouillé pour à emporter',
        delivery: 'Prix verrouillé pour livraison',
      },
      allergenes: {
        allergenes: 'Allergènes',
        cerealsWithGluten: 'Céréales contenant du gluten',
        crustaceans: 'Crustacés et produits dérivés',
        eggs: 'Œufs et produits dérivés',
        fish: 'Poissons et produits dérivés',
        peanuts: 'Arachides et produits dérivés',
        soya: 'Soja (haricots) et produits dérivés',
        milk: 'Lait et produits dérivés',
        nuts: 'Noix',
        celery: 'Céleri et produits dérivés',
        mustard: 'Moutarde et produits dérivés',
        sesame: 'Graines de sésame et produits dérivés',
        lupins: 'Lupins et produits dérivés',
        molluscs: 'Mollusques et produits dérivés',
        corn: 'Maïs et produits dérivés',
        wheat: 'Blé et produits dérivés',
        rye: 'Contient du blé et des produits dérivés',
        barley: 'Orge et produits dérivés',
        oats: 'Avoine et produits dérivés',
        spelt: 'Épeautre et produits dérivés',
        khorasan: 'Khorasan et produits dérivés',
        walnuts: 'Noix et produits dérivés',
        pecanNuts: 'Noix de pécan et produits dérivés',
        brazilNuts: 'Noix du Brésil et produits dérivés',
        pistachioNuts: 'Pistaches et produits dérivés',
        macadamiaNuts: 'Noix de macadamia et produits dérivés',
        almonds: 'Amandes et produits dérivés',
        hazelnuts: 'Contient des noisettes et des produits fabriqués à partir de celles-ci',
        cashews: 'Noix de cajou et produits dérivés',
        seeds: 'Graines et produits dérivés',
        poppySeeds: 'Graines de pavot et produits dérivés',
        sunflowerSeeds: 'Graines de tournesol et produits dérivés',
        poultryMeat: 'Viande de volaille et produits dérivés',
        beef: 'Viande bovine et produits dérivés',
        pigmeat: 'Viande porcine et produits dérivés',
        yeast: 'Extrait de levure',
        sulfurDioxideAndSulphites: 'Contient du dioxyde de soufre et des sulfites et des produits dérivés',
        rye2: 'Contient du seigle et des produits dérivés du seigle',
        gluten: 'Gluten',
      },
      additives: {
        additives: 'Additifs',
        1: 'avec colorant',
        2: 'avec conservateur',
        3: 'avec antioxydant',
        4: 'avec exhausteur de goût',
        5: 'contient des sulfites',
        6: 'noirci',
        7: 'avec phosphate',
        8: 'avec protéines de lait (pour produits à base de viande)',
        9: 'caféiné',
        10: 'quinine',
        11: 'avec édulcorant',
        12: 'ciré',
        13: 'Nouveau',
        14: "contient de l'alcool",
        15: 'contient du seigle et des produits dérivés',
        16: 'avec sel nitrité de salaison',
        17: "régulateur d'acidité",
        18: 'stabilisant',
        19: 'acidifiant',
      },
      traces: {
        traces: 'Traces',
        sesame: 'peut contenir des traces de sésame et de produits dérivés',
        soy: 'peut contenir des traces de soja et de produits dérivés',
        peanuts: "peut contenir des traces d'arachides et de produits dérivés",
        wheat: 'peut contenir des traces de blé et de produits dérivés',
        lupins: 'peut contenir des traces de lupins et de produits dérivés',
        treeNuts: 'peut contenir des traces de noix et de produits dérivés',
        sulfurDioxide: 'peut contenir des traces de dioxyde de soufre et de sulfites et de produits dérivés',
        fish: 'peut contenir des traces de poisson et de produits dérivés',
        milk: 'peut contenir des traces de lait et de produits dérivés',
        eggs: "peut contenir des traces d'œufs et de produits dérivés",
        mustard: 'peut contenir des traces de moutarde et de produits dérivés',
        barley: "peut contenir des traces d'orge et de produits dérivés",
      },
      nutrition: {
        portionInG: 'Portion (g)',
        portionInML: 'Portion (ml)',
        energyKcalPerPortion: 'Énergie (kcal)',
        energyKcalPer100G: 'Énergie (kcal/100g)',
        energyKcalPer100ML: 'Énergie (kcal/100ml)',
        energyKjPerPortion: 'Énergie (kj)',
        energyKjPer100G: 'Énergie (kj/100g)',
        energyKjPer100ML: 'Énergie (kj/100ml)',
        fatPerPortion: 'Matières grasses (g)',
        fatPer100G: 'Matières grasses (g/100g)',
        fatPer100ML: 'Matières grasses (g/100ml)',
        saturatesPerPortion: 'Acides gras saturés (g)',
        saturatesPer100G: 'Acides gras saturés (g/100g)',
        saturatesPer100ML: 'Acides gras saturés (g/100ml)',
        carbohydratePerPortion: 'Glucides (g)',
        carbohydratePer100G: 'Glucides (g/100g)',
        carbohydratePer100ML: 'Glucides (g/100ml)',
        sugarPerPortion: 'Sucres (g)',
        sugarPer100G: 'Sucres (g/100g)',
        sugarPer100ML: 'Sucres (g/100ml)',
        proteinPerPortion: 'Protéines (g)',
        proteinPer100G: 'Protéines (g/100g)',
        proteinPer100ML: 'Protéines (g/100ml)',
        saltPerPortion: 'Sel (g)',
        saltPer100G: 'Sel (g/100g)',
        saltPer100ML: 'Sel (g/100ml)',
        highFat: 'Teneur élevée en matières grasses',
        highSugar: 'Teneur élevée en sucres',
      },
      features: {
        basic: 'Basique',
        features: 'Caractéristiques',
        vegan: 'Végétalien',
        vegetarian: 'Végétarien',
        glutenFree: 'Sans gluten',
        noCarb: 'Sans glucides',
        alkaline: 'Alcalin',
        lactoseFree: 'Sans lactose',
        new: 'Nouveau',
        special: 'Spécial',
        topSelling: 'Meilleure vente',
        warm: 'Chaud',
        cold: 'Froid',
        fish: 'Poisson',
        chicken: 'Poulet',
        beef: 'Bœuf',
        pork: 'Porc',
        prepackaged: 'Préemballé',
        protein: 'Riche en protéines',
        healthy: 'Sain',
        menu: 'Menu',
        sticker: 'Autocollant',
        spicyLevel: {
          label: "Niveau d'épice",
          light: 'Épicé',
          medium: 'Très épicé',
          extra: 'Extra épicé',
        },
      },
    },
  },
  articleManager: {
    index: 'Visibilité des articles et options',
    overview: "Vue d'ensemble",
    mainArticle: 'Articles principaux',
    optionArticle: "Articles d'option",
    options: 'Options',
    deactivateAll: 'Désactiver tout',
    activateAll: 'Activer tout',
    onlyOne: 'Non, seulement celui-ci',
    wolt: 'Wolt',
    uberEats: 'Uber Eats',
    jet: 'Jet',
    filter: {
      category: 'Choisir une catégorie',
      status: "Choisir le statut de l'article",
      type: "Article ou article d'option",
      search: 'Rechercher',
      allStatus: 'Tous',
      active: 'Visible',
      notActive: 'Invisible',
      article: 'Article',
      options: 'Options',
    },
    table: {
      visibility: 'Visibilité',
      name: 'Nom',
      category: 'Catégorie',
      options: 'Options',
      price: 'Prix',
      optionGroup: "Groupe d'options",
      connectedArticles: 'Articles connectés',
      description: 'Description',
      loadMore: 'Charger plus',
    },
    notification: {
      saved: 'Modifications enregistrées.',
      sameArticleNumber:
        "Nous avons trouvé des articles avec le même numéro d'article. Souhaitez-vous activer/désactiver (selon l'action) tous, ou seulement celui-ci ?",
    },
  },
  translation: {
    start: "Traduction démarrée. Cela peut prendre jusqu'à 10 minutes",
    index: 'Traduction',
    overview: "Vue d'ensemble",
    translate: 'traduire',
    languages: {
      en: 'Anglais',
      de: 'Allemand',
      fr: 'Français',
      nl: 'Néerlandais',
      it: 'Italien',
      pl: 'Polonais',
      es: 'Espagnol',
      zh: 'Chinois',
      ru: 'Russe',
      tr: 'Turc',
      da: 'Danois',
      ja: 'Japonais',
      is: 'Islandais',
      pt: 'Portugais',
      cz: 'Tchèque',
      ar: 'Arabe',
      el: 'Grec',
      ko: 'Coréen',
      th: 'Thaï',
      vi: 'Vietnamien',
      hi: 'Hindi',
      ur: 'Ourdou',
      tl: 'Tagalog',
      id: 'Indonésien',
      no: 'Norvégien',
      sv: 'Suédois',
      lt: 'Lituanien',
      fi: 'Finnois',
    },
  },
  payment: {
    index: 'Paiements',
    overview: "Vue d'ensemble",
    refundArticle: "Rembourser l'article",
    refundArticleSmoothr: "Rembourser l'article Smoothr uniquement",
    refundOrder: 'Rembourser la commande',
    refundOrderSmoothr: 'Rembourser la commande Smoothr uniquement',
    refundPosOnly: 'Rembourser uniquement le POS',
    refundQuestion: 'Êtes-vous sûr de vouloir rembourser ? Cette action est irréversible.',
    refunded: "Fait partie d'un remboursement",
    order: 'Commande',
    refund: 'Remboursements disponibles',
    searchCode: 'Rechercher par code de commande...',
    searchTransactionId: 'Rechercher par identifiant de transaction...',
    sendInvoice: 'Envoyer la facture',
    showLogs: 'Afficher les journaux',
    hideLogs: 'Masquer les journaux',
    logs: {
      logs: 'Journaux de paiement',
      noLogs: 'Aucun journal de paiement trouvé pour cette commande.',
      payment: 'Paiement',
      provider: 'Fournisseur de paiement',
      venue: 'Venue',
      messageType: 'Type de message',
      httpMethod: 'Méthode HTTP',
      httpStatusCode: 'Code de statut HTTP',
      url: 'URL',
      endpoint: 'Point de terminaison',
      result: 'Résultat',
      createdAt: 'Date de création',
      updatedAt: 'Date de mise à jour',
      expiresAt: "Date d'expiration",
    },
    notification: {
      invoiceSent: 'La facture a été envoyée avec succès.',
    },
    table: {
      sum: 'Somme',
      tip: 'Pourboire',
      status: 'Statut',
      hasRefunds: 'Remboursements',
      codes: 'Codes',
      method: 'Méthode de paiement',
      createdAt: 'Date',
      id: 'Id',
      merchantReference: 'Référence du marchand',
      checkoutId: 'Référence PSP',
      subMethod: 'Sous-méthode',
      orderedArticles: 'Articles commandés',
      checkoutOrderedArticles: 'Articles commandés au moment du paiement',
    },
    form: {
      quantity: 'Quantité',
      email: 'E-mail',
    },
  },
  option: {
    index: 'Gérer les options',
    create: 'Créer une nouvelle option',
    edit: "Modifier l'option",
    add: 'Ajouter une option',
    copy: "Copier l'option",
    unlinkedOptions: 'Options non attachées aux articles',
    empty:
      "Il semble que vous n'ayez pas encore ajouté d'options. Créez votre premier groupe d'options pour créer des articles encore meilleurs et personnalisables.",
    overview: "Vue d'ensemble",
    tabs: {
      general: 'Général',
      articles: 'Articles',
      features: 'Caractéristiques',
      availableHours: 'Heures disponibles',
      compound: {
        features: 'Caractéristiques',
        new: 'Nouveau',
        special: 'Spécial',
        topSelling: 'Meilleure vente',
      },
    },
    articles: {
      table: {
        name: 'Nom',
        description: 'Description',
        price: 'Prix',
        sortOrder: 'Trier',
        internalNote: 'Note interne',
        internalName: 'Nom interne',
        assets: 'Images',
        active: 'Actif',
        visible: 'Visible',
        number: 'Numéro',
      },
      addTitle: 'Ajouter un article',
      editTitle: "Modifier l'article",
    },
    table: {
      name: 'Nom',
      description: 'Description',
      requiredAmount: 'Quantité requise',
      limit: 'Limite',
      hasMultiple: 'A plusieurs',
      sortOrder: 'Trier',
      visible: 'Visible',
      article: 'Article',
    },
    form: {
      name: 'Nom',
      description: 'Description',
      shortDescription: 'Description courte',
      image: 'Image',
      externalId: 'ID externe',
      limit: 'Limite',
      active: 'Actif',
      visible: 'Visible',
      virtual: 'Virtuel',
      sort: 'Trier',
      printerSort: "Tri d'imprimante",
      requiredAmount: 'Quantité requise',
      hasMultiple: 'Multiple',
      displayIdentifiers: "Identifiants d'affichage",
      displayMode: "Mode d'affichage",
      displayModeSot: "Mode d'affichage SOT",
      displayModeMobile: "Mode d'affichage mobile",
      tags: 'Étiquettes',
      printGroups: "Groupes d'impression",
    },
    deleteHeader: 'Supprimer les options',
    deleteInfo: 'Êtes-vous sûr de vouloir supprimer ces options ? Cette action est irréversible.',
    deleteSelected: 'Supprimer la sélection',
  },
  category: {
    index: 'Gérer les catégories',
    create: 'Créer une nouvelle catégorie',
    edit: 'Modifier la catégorie',
    add: 'Ajouter une catégorie',
    overview: "Vue d'ensemble",
    availableHours: 'Heures disponibles',
    table: {
      name: 'Nom',
      sort: 'Trier',
      mainCategory: 'Catégorie principale',
      visible: 'Visible',
    },
    form: {
      name: 'Nom',
      description: 'Description',
      mainCategory: 'Catégorie principale',
      sort: 'Trier',
      displayMode: "Mode d'affichage",
      mainRecommendations: 'Recommandations principales',
      displayIdentifiers: "Identifiants d'affichage",
      visible: 'Visible',
      image: 'Image',
      icon: 'Icône',
    },
    tabs: {
      features: 'Caractéristiques',
      new: 'Nouveau',
      special: 'Spécial',
      topSelling: 'Meilleure vente',
    },
  },
  subscriptionCategories: {
    index: "Gérer la catégorie d'abonnement",
    create: "Créer une nouvelle catégorie d'abonnement",
    edit: "Modifier la catégorie d'abonnement",
    add: "Ajouter une catégorie d'abonnement",
    overview: "Vue d'ensemble",
    table: {
      name: 'Nom',
    },
    form: {
      name: 'Nom',
      description: 'Description',
      image: 'Image',
      subscriptions: 'Abonnements',
      venues: 'Restaurants',
      canCombine: 'Combiner',
      isActive: 'Actif',
    },
  },
  subscription: {
    index: "Gérer l'abonnement",
    create: 'Créer un nouvel abonnement',
    edit: "Modifier l'abonnement",
    add: 'Ajouter un abonnement',
    overview: "Vue d'ensemble",
    table: {
      name: 'Nom',
    },
    form: {
      name: 'Nom',
      description: 'Description',
      image: 'Image',
      useMasterFoodcard: 'Utiliser la carte alimentaire principale',
      maxPricePerOrder: 'Prix maximum par commande',
      maxPricePerArticle: 'Prix maximum par article',
      maxArticlesPerOrder: 'Articles maximum par commande',
      maxOrdersPerDay: 'Commandes maximum par jour',
      minimumOrderOffset: 'Délai minimum de commande',
      isActive: 'Actif',
      automaticallyRenew: 'Renouvellement automatique',
      tax: 'Taxe',
      articles: 'Articles',
      venues: 'Restaurants',
      linkedCustomerGroup: 'Groupe de clients lié',
      price: 'Prix',
      factor: 'Facteur',
      unit: 'Unité',
      default: 'Par défaut',
    },
  },
  membership: {
    index: "Gérer l'adhésion",
    create: 'Créer une nouvelle adhésion',
    edit: "Modifier l'adhésion",
    add: 'Ajouter une adhésion',
    overview: "Vue d'ensemble",
    table: {
      name: 'Nom',
    },
    form: {
      name: 'Nom',
      description: 'Description',
      image: 'Image',
      multiplier: 'Multiplicateur',
      neededPoints: 'Points nécessaires',
      piggyId: 'ID Piggy',
      customerGroup: 'Groupe de clients',
    },
    tier: {
      membershiptier1: "niveau d'adhésion 1",
      membershiptier2: "niveau d'adhésion 2",
      membershiptier3: "niveau d'adhésion 3",
      membershiptier4: "niveau d'adhésion 4",
      membershiptier5: "niveau d'adhésion 5",
    },
  },
  table: {
    index: 'Gérer les tables',
    create: 'Créer une nouvelle table',
    exportQrs: 'Exporter les codes QR',
    assignLightspeedWaiter: 'Assigner le serveur Lightspeed',
    toggleTablesByRange: 'Basculer les tables par plage',
    toggleTablesByTag: 'Basculer les tables par étiquette',
    edit: 'Modifier la table',
    add: 'Ajouter une table',
    overview: "Vue d'ensemble",
    table: {
      number: 'Numéro',
      description: 'Description',
      active: 'Actif',
      tags: 'Étiquettes',
      qr: 'Code QR',
      sanifairDeviceId: "ID d'appareil Sanifair",
    },
    form: {
      number: 'Numéro',
      description: 'Description',
      sanifairDeviceId: "ID d'appareil Sanifair",
      lightspeedWaiterId: 'Serveur Lightspeed',
      simphonyRvcRef: 'Identifiant du centre de revenus Simphony',
      mollieTerminalId: 'Terminal Mollie',
      pendingCashPaymentEnabled: 'Activer les paiements en espèces ouverts',
      openOrdersEnabled: 'Activer les commandes ouvertes',
      viewStaff: 'Voir le personnel',
      select: 'Sélectionner',
      isActive: 'Actif',
      start: 'Début',
      end: 'Fin',
      tag: 'Étiquette',
    },
    notification: {
      mollieTerminalsError: 'Impossible de charger les terminaux Mollie.',
      assignLightspeedWaiterSuccess: 'Le serveur Lightspeed a été assigné avec succès aux tables sélectionnées.',
      assignLightspeedWaiterError:
        "Une erreur est survenue lors de l'assignation du serveur Lightspeed aux tables sélectionnées.",
      massActiveSuccess: 'Les tables ont été mises à jour avec succès.',
      massActiveError: 'Une erreur est survenue lors de la mise à jour des tables.',
    },
  },
  venue: {
    index: 'Gérer les restaurants',
    create: 'Créer un nouveau restaurant',
    copyFoodcard: 'Copier la carte alimentaire',
    editMasterId: "Modifier l'ID maître",
    copyArticles: 'Copier les articles',
    importHellotess: 'Importer la carte alimentaire depuis Hellotess',
    importGastrofix: 'Importer la carte alimentaire depuis Gastrofix',
    importDeliverect: 'Importer la carte alimentaire depuis Deliverect',
    importSimphony: 'Importer la carte alimentaire depuis Simphony',
    generalImport: 'Importation générale de carte alimentaire',
    panic: 'Panique',
    ppConnected: 'Statut du compte PayPal',
    ppConnectedSuccess: 'Compte PayPal connecté avec succès.',
    ppConnectedError: "Le compte PayPal n'est pas connecté ou a échoué.",
    lightspeedAuthorize: 'Autoriser Lightspeed',
    lightspeedAuthorized: 'Lightspeed autorisé avec succès',
    lightspeedNotAuthorized: 'Lightspeed non autorisé',
    generateSlugAuto: 'Générer automatiquement le slug',
    standardSlots: 'Créneaux standard',
    terminalSlots: 'Créneaux terminal',
    preorderSlots: 'Créneaux de précommande',
    createSimple: 'Créer un nouveau restaurant',
    overview: "Vue d'ensemble",
    add: 'Ajouter un restaurant',
    sync: 'Synchroniser le restaurant',
    tooltipCannotSync: 'La synchronisation est déjà en cours. Veuillez patienter ou contacter un administrateur',
    liftSyncLock: 'Lever le verrou de synchronisation',
    refresh: 'Actualiser',
    copy: 'Copier le restaurant',
    copyVenueOnly: 'Copier uniquement le restaurant',
    deleteFoodcard: 'Supprimer la carte alimentaire',
    copyConfirm: 'Êtes-vous sûr de vouloir créer un doublon du restaurant ?',
    copySuccess: 'Le restaurant a été copié',
    archive: 'Archiver',
    testOrder: 'Envoyer une commande test',
    registerPayPal: 'Connecter le compte PayPal',
    checkPayPalOnboarding: "Vérifier l'état du compte PayPal",
    deliveryFees: 'Frais de livraison',
    deliveryFeesRadius: 'Frais de livraison par rayon',
    deliveryFeesPostalCode: 'Frais de livraison par code postal',
    deliveryFeesAreas: 'Frais de livraison par zones',
    edit: 'Modifier le restaurant',
    parkCollect: 'Park & Collect',
    migrate: 'Migrer le restaurant',
    stations: 'Stations',
    migration: 'Migration',
    eodReport: 'Rapport de fin de journée',
    customerSupportMail: 'Support client',
    generateWebAppSlug: "Générer le slug de l'application web",
    panicInfo:
      "Information : La panique pour le restaurant {venue} est activée jusqu'à {panicEndAt} heure(s). {reason}.",
    snoozing: 'Options de mise en veille',
    offsetReset: 'Heure de réinitialisation du décalage',
    milesAndMore: 'Miles & More',
    kost: 'KOST',
    ncr: 'NCR',
    revel: 'Revel',
    fullcircle: 'fullcircle POS',
    arcavis: 'Arcavis',
    orderbird: 'Orderbird',
    erpVoucher: 'Bon ERP',
    tips: 'Pourboires',
    notification: {
      testOrderSuccess: 'La commande test a réussi.',
      testOrderError:
        'La commande test a échoué. Veuillez vérifier vos paramètres ou si vous avez encore des problèmes, contactez un administrateur.',
      sendInvoiceSuccess: 'La facture a été envoyée avec succès.',
      createCreditNoteSuccess: "L'avoir a été créé avec succès.",
      registerPayPalError: "Impossible d'autoriser PayPal.",
      connectMollieSuccess: 'Mollie a été connecté avec succès.',
      connectMollieError: 'La connexion à Mollie a échoué.',
      disconnectMollieSuccess: 'Mollie a été déconnecté.',
      disconnectMollieError: 'La déconnexion de Mollie a échoué.',
      checkPayPalOnboardingError: "Impossible de vérifier l'état d'intégration de PayPal.",
      checkPayPalOnboardingSuccess: 'Veuillez actualiser la page pour voir les changements.',
      sendInvoiceError: "L'envoi de la facture a échoué.",
      createCreditNoteError: "La création de l'avoir a échoué.",
      copyOptionSuccess: "L'option a été copiée",
      copyOptionError: "La copie de l'option a échoué. Veuillez vérifier les journaux.",
      authorizePayPal:
        'Pour autoriser, veuillez remplir les champs ID marchand et E-mail dans les identifiants PayPal et enregistrer.',
      copyRunning: 'La copie du restaurant a démarré et est en cours.',
      copyError: 'La copie du restaurant a échoué. Veuillez vérifier les journaux.',
      webAppSlug:
        "Êtes-vous sûr de vouloir générer le champ Slug de l'application web ? Dans ce cas, cela sera fait pour tous les restaurants.",
      masterId: 'ID maître',
      deleteSuccess: 'Carte alimentaire supprimée avec succès !',
      refreshSuccess: "L'actualisation du restaurant s'est terminée avec succès.",
      refreshError: "Une erreur est survenue lors de l'actualisation du restaurant.",
      sepa: {
        createSuccess: "Le nouveau lien d'enregistrement du mandat SEPA a été créé avec succès",
        createError: "Impossible de créer un nouveau lien d'enregistrement de mandat SEPA",
        paySuccess: 'Le nouveau paiement SEPA a été créé avec succès',
        payError: 'Impossible de créer un nouveau paiement SEPA',
      },
    },
    filter: {
      publishedStatus: 'Statut de publication',
      published: 'Publié',
      unpublished: 'Non publié',
      verifiedStatus: 'Statut de vérification',
      syncStatus: 'Statut de synchronisation',
      idle: 'Non synchronisé',
      sync: 'Synchronisation',
      verified: 'Vérifié',
      customerGroup: 'Groupe de clients',
      unverified: 'Non vérifié',
      deletedAt: 'Voir les archives',
      isServiceActivatedStatus: "Statut d'activation du service",
      deliveryEnabledStatus: "Statut d'activation de la livraison",
      panicModeStatus: 'Statut de panique',
      activated: 'Activé',
      notActivated: 'Non activé',
      enabled: 'Activé',
      notEnabled: 'Non activé',
      panicActive: 'En cours',
      panicInactive: 'Inactif',
    },
    station: {
      placeholder: 'Tapez le nom de la station',
      deleteStation: 'Êtes-vous sûr de vouloir supprimer la station ?',
      addStation: '+ Ajouter une station',
    },
    confirmation: {
      verify: {
        title: 'Confirmation du restaurant',
        text: "En cliquant sur le bouton ci-dessous, vous acceptez que tous les articles, prix et paramètres du restaurant sont corrects. De plus, vous avez téléchargé les CGV, la politique de confidentialité et l'avertissement. Pour tout paramètre incorrect, vous en êtes responsable.",
        action: 'Vérifier le restaurant',
      },
      publish: {
        title: 'Confirmation de publication',
        text: 'En cliquant sur le bouton ci-dessous, vous acceptez que tous les articles, prix et paramètres du restaurant sont corrects. Pour tout paramètre incorrect, vous en êtes responsable.',
        action: 'Publier le restaurant',
      },
      deleteFoodcard: {
        title: 'Êtes-vous sûr de vouloir supprimer toute la carte alimentaire ?',
        text: "Vous supprimez toutes les catégories, articles, groupes d'options, articles d'options et étiquettes avec cette action.<br/><br/>Cette action est irréversible.",
      },
    },
    verify: 'Vérifier',
    publish: 'Publier',
    credentials: 'Identifiants',
    payment: 'Paiement',
    order: 'Commande',
    preorder: 'Précommande',
    slotting: 'Paramètres de créneaux',
    documents: 'Documents',
    invoices: {
      createCreditNote: 'Créer un avoir',
      createCreditNoteNet: 'Créer un avoir (Valeur nette)',
      send: 'Envoyer la facture',
      transactions: 'Transactions',
      balance: 'Solde',
      type: 'Type de facture',
      refOrNote: 'Référence/Note de facture',
      createdAt: 'Créé le',
      amount: 'Montant',
      setupFee99: "Frais d'installation (99€)",
      setupFee49: "Frais d'installation (49€)",
      premiumPrinterPackage: "Pack d'imprimante premium",
      printerTablet: 'Tablette avec imprimante intégrée (319,00 + 8,00 €)',
      printerTablet200: 'Tablette avec imprimante intégrée (200€ + 8€)',
      printerTablet230: 'Tablette avec imprimante intégrée (230€ + 8€)',
      provision: 'Commission',
      creditNoteNet: 'Avoir (Valeur nette)',
      status: 'Statut',
    },
    productCombos: {
      addCombo: 'Ajouter un combo',
      addArticle: 'Ajouter un article',
      addColumn: 'Ajouter une colonne',
      deleteColumn: 'Supprimer la colonne',
      result: "Sélectionner l'article résultat",
      column: "Sélectionner l'article",
    },
    ci: 'Intégration de paiement',
    cip: "Propriétés d'intégration de paiement",
    general: 'Général',
    details: 'Détails',
    contact: 'Contact',
    whiteLabel: 'Marque blanche',
    invoiceReceiver: 'Adresse postale',
    address: 'Adresse',
    settings: 'Paramètres',
    sizeSettings: 'Paramètres de taille',
    orderOffsets: 'Décalages de commande',
    preorderOffsets: 'Décalages de précommande',
    fireTimeOffsets: 'Décalages de déclenchement',
    uberDelivery: 'Livraison Uber',
    miscellaneous: 'Divers',
    preorderPayment: 'Paiement de précommande',
    deliveryPayment: 'Paiement de livraison en précommande',
    sepaCredentials: 'Identifiants SEPA',
    ccCredentials: 'Identifiants de carte de crédit',
    ppCredentials: 'Identifiants PayPal',
    sbCredentials: 'Identifiants de virement instantané',
    apCredentials: 'Identifiants Apple Pay',
    gpCredentials: 'Identifiants Google Pay',
    walleeCredentials: 'Identifiants Wallee',
    worldlineCredentials: 'Identifiants Worldline',
    datatransCredentials: 'Identifiants DataTrans',
    adyenCredentials: 'Identifiants Adyen',
    walleePaymentConfs: 'Paiement Wallee',
    neptingCredentials: 'Identifiants Nepting',
    eServiceCredentials: 'Identifiants eService',
    mollieCredentials: 'Identifiants Mollie',
    connectMollie: 'Connecter le compte Mollie',
    disconnectMollie: 'Déconnecter le compte Mollie',
    iCouponCredentials: 'Identifiants iCoupon',
    openingHours: "Heures d'ouverture",
    specialOpeningHours: "Heures d'ouverture spéciales",
    deliveryHours: 'Heures de livraison',
    specialDeliveryHours: 'Heures de livraison spéciales',
    salesforce: 'Salesforce',
    salesforcePromotions: 'Promotions Salesforce',
    sanifair: 'Sanifair',
    delfi: 'Delfi',
    loyalty: 'Fidélité',
    loyaltyManagedGifts: {
      title: 'Cadeaux Como gérés',
      venueGifts: 'Cadeaux du restaurant',
      metadata: 'Métadonnées du cadeau',
      venue: 'Restaurant',
      name: 'Nom',
      description: 'Description',
      type: 'Type de cadeau',
      status: 'Statut',
      requiredPoints: 'Points requis',
      templateKey: 'Clé du modèle',
      giftId: 'ID du cadeau',
      imageThumb: 'URL de la miniature',
      imageMedium: 'URL de l’image moyenne',
      imageLarge: 'URL de la grande image',
      imageOriginal: 'URL de l’image originale',
      image: 'Image du cadeau',
      create: 'Créer les métadonnées du cadeau',
      deleteQuestion: 'Supprimer ces métadonnées ? Le cadeau utilisera le texte Como.',
      giftTypes: { reward: 'Récompense', point_shop_gift: 'Cadeau de la boutique de points' },
      statuses: { active: 'Actif', inactive: 'Inactif' },
    },
    boardingPass: "Carte d'embarquement",
    datev: 'Datev',
    storeLink: 'Lien du magasin',
    viewCounters: 'Compteurs de vues',
    voucherify: 'Voucherify',
    grubtech: 'GrubTech',
    finances: 'Finances',
    nutrition: 'Nutrition',
    panicModeHistory: {
      startAt: 'Début de la panique',
      endAt: 'Fin de la panique',
      reason: 'Raison de la panique',
    },
    locTypes: {
      bar: 'Bar',
      club: 'Club',
      restaurant: 'Restaurant',
      db: 'Deutsche Bahn',
      cinema: 'Cinéma',
      other: 'Autre',
    },
    tabs: {
      general: 'Général',
      payment: 'Paiement',
      terminal: 'Terminal',
      preorder: 'Précommande',
      ci: 'Intégration de paiement',
      orderOffsets: 'Décalages de commande',
      order: 'Commande',
      slotting: 'Créneaux',
      cateringHours: 'Heures traiteur',
      documents: 'Documents',
      openingHours: "Heures d'ouverture",
      productCombos: 'Combinaisons de produits',
      deliveryHours: 'Heures de livraison',
      deliveryProviders: 'Fournisseurs de livraison',
      externalDeliveryService: 'Service de livraison externe',
      orderProviders: 'Fournisseurs de commande',
      invoices: 'Factures',
      sanifair: 'Sanifair',
      salesforce: 'Salesforce',
      delfi: 'Delfi',
      loyalty: 'Fidélité',
      boardingPass: "Carte d'embarquement",
      datev: 'Datev',
      milesAndMore: 'Miles & More',
      erpVoucher: 'Bon ERP',
      tips: 'Pourboires',
      voucherify: 'Voucherify',
      grubtech: 'GrubTech',
      finances: 'Finances',
      nutrition: 'Nutrition',
    },
    table: {
      name: 'Nom',
      shortId: 'ID court',
      sort: 'Trier',
      email: 'E-mail',
      street: 'Rue',
      number: 'Numéro',
      city: 'Ville',
      legalForm: 'Forme juridique',
      locType: 'Type',
      vatNumber: 'Numéro de TVA',
      vatNumberGermany: "Numéro d'identification fiscale allemand",
      isServiceActivated: 'Service activé',
      deliveryEnabled: 'Livraison activée',
      customerGroup: 'Groupe de clients',
      checkoutIntegration: 'Intégration de paiement',
      piggyLoyaltyEnabled: 'Fidélité',
      isPublished: 'Publié',
      webAppSlug: "Slug de l'application web",
      masterId: 'ID maître',
      externalOrderProviderStatus: 'Statut du magasin (Wolt/Uber Eats)',
      preorderTakeAway: 'Précommande à emporter',
      panicModeHistory: 'Historique de panique',
      cases: 'Cas',
    },
    form: {
      secondaryCodeEnabled: 'Code secondaire activé',
      standardOrderOffsets: 'Décalages de commande standard',
      terminalInsideOffsets: 'Décalages sur place terminal',
      terminalTakeAwayOffsets: 'Décalages à emporter terminal',
      preorderInsideOffsets: 'Décalages sur place précommande',
      preorderTakeAwayOffsets: 'Décalages à emporter précommande',
      preorderDeliveryOffsets: 'Décalages de livraison précommande',
      cateringTakeAway: 'Autoriser le traiteur à emporter',
      cateringDelivery: 'Autoriser la livraison traiteur',
      cateringTakeAwayHours: 'Heures de traiteur à emporter',
      cateringDeliveryHours: 'Heures de livraison traiteur',
      cateringDeliveryOffsets: 'Décalages de livraison traiteur',
      cateringTakeAwayOffsets: 'Décalages à emporter traiteur',
      couponsEnabled: 'Couponnage',
      cateringSlots: 'Créneaux traiteur',
      parkCollectionLocationText: "Texte de l'emplacement",
      venue: 'Restaurant',
      masterId: 'ID maître',
      sort: 'Trier',
      sourceVenue: 'Restaurant source',
      targetVenue: 'Restaurant cible',
      sendEodReport: 'Envoyer le rapport de fin de journée aux e-mails',
      sendEodReportEmails: "Liste d'e-mails pour envoyer les rapports",
      source: 'Source',
      image: 'Image',
      masterType: 'Type de commande',
      uberCustomerId: 'ID client Uber',
      uberDeliveryEnabled: 'Livraison Uber activée',
      uberBatchSize: 'Taille du lot',
      externalDeliveryService: {
        name: 'Nom',
        link: 'Lien',
        icon: 'Icône',
      },
      name: 'Nom',
      newName: 'Nouveau nom',
      asSlave: 'Créer le restaurant comme esclave du restaurant sélectionné',
      sapNumber: 'Numéro SAP',
      externalLocationId: 'ID de lieu externe',
      loginRequired: 'Conditions de connexion',
      restaurantToken: 'Jeton de restaurant Smoothr',
      standardSlot: 'Max. commandes standard par intervalle',
      takeAwaySlot: 'Max. commandes à emporter par intervalle',
      calculateDays: 'Nombre de jours pour calculer les créneaux',
      insideSlot: 'Max. commandes sur place par intervalle',
      deliverySlot: 'Max. commandes de livraison par intervalle',
      properties: 'Propriétés',
      syncType: 'Type de synchronisation',
      fullName: "Nom de l'entreprise",
      currency: 'Devise',
      deliveryPostalCodes: 'Codes postaux de livraison',
      deliveryPostalCodesHint: 'Veuillez insérer un code postal avec une ville correspondante (ex: 50679 Cologne)',
      country: 'Pays',
      locType: 'Type de lieu',
      deliveryFee: 'Frais de livraison en {currency} (si non spécifié autrement)',
      deliveryByRadius: 'Utiliser le rayon de livraison (Sinon par codes postaux)',
      deliveryByAreas: 'Utiliser les zones de livraison (Sinon par codes postaux)',
      provisionRate: 'Taux de commission',
      bcsig: 'BCSIG',
      supplier: 'Fournisseur',
      webAppUrl: "URL de l'application web",
      panicEndAt: 'Panique (si actif, les précommandes ne sont pas possibles)',
      provisionFixedRate: 'Taux de commission fixe',
      readableId: 'ID court',
      migrationType: 'Type de migration',
      deliveryRadius: 'Rayon de livraison',
      deliveryRadiusMax: 'Rayon de livraison (max)',
      isPublished: 'Publié',
      venues: 'Restaurants',
      deliveryHours: 'Heures de livraison',
      sanifair: 'Paramètres Sanifair',
      active: 'Actif',
      virtualOrders: 'Autoriser les commandes virtuelles',
      stock: 'Stock',
      movDelivery: 'Valeur minimale de commande - Livraison (EUR)',
      checkoutIntegration: 'Intégration de paiement',
      printerIntegration: "Intégration d'imprimante",
      readyOffset: 'Décalage de préparation',
      readyOffsetDelivery: 'Décalage de préparation livraison',
      interval: "Taille de l'intervalle",
      reserved: 'Commandes réservées',
      max: "Commandes max dans l'intervalle (obsolète)",
      notPickedOffset: 'Décalage non récupéré',
      isServiceActivated: 'Statut du service (si non activé, la commande est désactivée)',
      isCallingSystemEnabled: "Système d'appel",
      inventoryEnabled: 'Inventaire activé',
      milesAndMoreEnabled: 'Miles & More activé',
      erpVoucherEnabled: 'Bon ERP activé',
      legalForm: 'Forme juridique',
      email: 'E-mail',
      orderEmail: 'E-mail de commande',
      storeEmail: 'E-mail du magasin',
      web: 'Site web',
      standardOrders: 'Autoriser les commandes standard',
      preorderTakeAway: 'Autoriser la précommande à emporter',
      preorderParkCollect: 'Autoriser Park & Collect',
      preorderFoodspot: 'Autoriser Foodspot',
      preorderIn: 'Autoriser la précommande sur place',
      preorderDelivery: 'Autoriser la livraison',
      autoAccept: 'Accepter automatiquement dans',
      autoAcceptTerminal: 'Accepter automatiquement la commande terminal dans',
      checkoutIn: 'Payer dans',
      printIn: 'Imprimer dans',
      autoReset: 'Réinitialisation automatique dans',
      orderTimeout: "Délai d'expiration de la commande",
      orderTimeoutEnabled: "Activer le délai d'expiration de la commande",
      phone: 'Téléphone',
      fax: 'Fax',
      city: 'Ville',
      area: 'Ville la plus proche',
      street: 'Rue',
      streetAddress: 'Adresse',
      number: 'Numéro',
      company: 'Entreprise',
      postalCode: 'Code postal',
      federalState: 'État fédéral',
      deliveryAddress: 'Adresse de livraison',
      orderPrinterTabletPackageInfo:
        'Commander une tablette avec imprimante intégrée pour {price}€. Sans imprimante, vous ne recevez que les nouvelles commandes par e-mail.',
      orderPremiumPackage: "Commander l'imprimante",
      timezone: 'Fuseau horaire',
      googlePlacesId: 'ID Google Places',
      customerGroup: 'Groupe de clients',
      sendProvisionReportPeriod: 'Envoyer le rapport de commission',
      lastInvoiceNumber: 'Dernier numéro de facture',
      sendProvisionReportPeriodNonInvoiceable: 'Envoyer le rapport de commission (sans numéro de facture)',
      vatNumber: 'Numéro de TVA',
      vatNumberQuestion: 'Utiliser le numéro de TVA ?',
      vatNumberGermany: "Numéro d'identification fiscale allemand (ex: 12/345/67890)",
      vatNumberGermanyQuestion: 'Pas de numéro de TVA ?',
      mov: 'VMC',
      from: 'De',
      fee: 'Frais',
      deliveryArea: 'Zone de livraison',
      secureCode: 'Code sécurisé',
      selfCertification: 'Auto-certification',
      reviewHyperlink: "Lien hypertexte d'avis",
      pdfUpload: 'Télécharger le fichier PDF',
      kmlUpload: 'Télécharger le fichier KML',
      insertLink: 'Insérer un lien',
      nutritionTable: 'Tableau nutritionnel',
      nutritionInfo: 'Information nutritionnelle',
      gpsManualInput: 'Saisie manuelle (Coordonnées GPS)',
      gpsCorrect: 'Coordonnées GPS correctes ?',
      latitude: 'Latitude',
      longitude: 'Longitude',
      adyenEnabled: 'Adyen activé',
      adyenPaypalEnabled: 'Adyen PayPal activé',
      merchantAccount: 'Compte marchand',
      urlPrefix: "Préfixe d'URL",
      clientKey: 'Clé client',
      property: 'Propriété',
      paymentEnabled: 'Paiement activé',
      sepaEnabled: 'SEPA activé',
      sbEnabled: 'Virement instantané activé',
      gpEnabled: 'Google Pay activé',
      apEnabled: 'Apple Pay activé',
      ppEnabled: 'PayPal activé',
      vrPaymentEnabled: 'VR activé',
      rekaEnabled: 'Reka activé',
      twintEnabled: 'Twint activé',
      walleeEnabled: 'Wallee activé',
      tacEnabled: 'Tac activé',
      comoLoyaltyEnabled: 'Como Loyalty activé',
      tipRefundEnabled: 'Remboursement de pourboire activé',
      alipayEnabled: 'Alipay activé',
      wcEnabled: 'WeChat Pay activé',
      bcEnabled: 'Boncard activé',
      lchEnabled: 'Luncheck activé',
      cwlEnabled: 'Worldline activé',
      ccvEnabled: 'CCV activé',
      zeroPaymentEnabled: 'Paiement zéro activé',
      woltPaymentEnabled: 'Paiement Wolt activé',
      uberEatsPaymentEnabled: 'Paiement Uber Eats activé',
      jetPaymentEnabled: 'Paiement JET activé',
      deliverooPaymentEnabled: 'Paiement Deliveroo activé',
      kostCardPaymentEnabled: 'Paiement par carte KOST activé',
      ctCreditCardPaymentEnabled: 'Carte de crédit Computop activée',
      bankTransferPaymentEnabled: 'Virement bancaire activé',
      dataTransEnabled: 'DataTrans activé',
      piggyGiftCardEnabled: 'Carte-cadeau Piggy activée',
      piggyPrepaidBalanceEnabled: 'Solde prépayé Piggy activé',
      comoGiftCardEnabled: 'Carte-cadeau Como activée',
      sapCCOEnabled: 'SAP CCO activé',
      worldlineEnabled: 'Worldline activé',
      wlApplePayEnabled: 'Worldline Apple Pay activé',
      wlApplePayMobileEnabled: 'Worldline Apple Pay mobile activé',
      wlGooglePayEnabled: 'Worldline Google Pay activé',
      wlGooglePayMobileEnabled: 'Worldline Google Pay mobile activé',
      wlCardEnabled: 'Worldline Carte activée',
      wlCardMobileEnabled: 'Worldline Carte mobile activée',
      pfEnabled: 'PostFinance E-Finance activé',
      pfcEnabled: 'PostFinance Card activé',
      ppV2Enabled: 'PayPal V2 activé',
      ppFullIntegrationEnabled: 'Intégration complète PayPal activée',
      ccEnabled: 'Carte de crédit activée',
      posEnabled: 'PDV activé',
      cashEnabled: 'Espèces activées',
      neptingEnabled: 'Nepting activé',
      eServiceEnabled: 'eService activé',
      mollieEnabled: 'Mollie activé',
      mollieTestmode: 'Mode test Mollie (hors production uniquement)',
      iCouponEnabled: 'iCoupon activé',
      vippsEnabled: 'Vipps activé',
      swishEnabled: 'Swish activé',
      mobilePayEnabled: 'MobilePay activé',
      dankortEnabled: 'Dankort activé',
      maxxvendEnabled: 'MAXXvend activé',
      amexEnabled: 'Amex activé',
      secretKey: 'Clé secrète',
      merchantName: 'Nom du marchand',
      creditorId: 'ID créancier',
      merchantId: 'ID marchand',
      merchantIdPP: 'ID marchand',
      serviceProviderRef: 'Référence du fournisseur de services',
      outletRef: 'Référence du point de vente',
      locationRef: 'Référence du lieu',
      userId: 'ID utilisateur',
      spaceId: "ID d'espace",
      userKey: 'Clé utilisateur',
      reka: 'Reka',
      twint: 'Twint',
      boncard: 'Boncard',
      luncheck: 'Luncheck',
      postfinance: 'Postfinance',
      postfinanceCard: 'Postfinance Card',
      wechat: 'Wechat',
      alipay: 'Alipay',
      worldline: 'Worldline',
      ppEmail: 'E-mail du compte',
      ppEmailConfirmed: 'E-mail PayPal confirmé',
      ppEmailNotConfirmed: 'E-mail PayPal non confirmé',
      ppPaymentsReceivable: 'Les paiements PayPal sont recevables',
      ppPaymentsNotReceivable: 'Les paiements PayPal ne sont pas recevables',
      vrAccessToken: "Jeton d'accès VR-Payment",
      receiptLogo: 'Logo de reçu',
      articleSpanCount: "Nombre de colonnes d'articles",
      categorySpanCount: 'Nombre de colonnes de catégories',
      fullWidthCategories: 'Catégories en pleine largeur',
      showInactiveArticles: 'Afficher les articles interactifs',
      askForTableNumber: 'Demander le numéro de table',
      foodAndBeveragesSeparated: 'Nourriture et boissons séparées',
      toolbarTitleHidden: "Titre de la barre d'outils masqué",
      displayCirclePickerDescription: 'Afficher la description du sélecteur circulaire',
      toolbarCategoryListVisible: "Liste des catégories de la barre d'outils visible",
      toolbarSidesVisible: "Côtés de la barre d'outils visibles",
      multiLanguage: 'Multilingue',
      printQr: 'Imprimer le QR',
      firstOrderOffset: 'Décalage de commande le plus tôt',
      orderOffset: 'Décalage minimum de commande',
      lastOrderOffset: 'Décalage de commande le plus tard',
      dailyUnsnoozeTime: "Décalage d'article",
      offsetResetEnabled: 'Réinitialisation du temps de préparation activée',
      offsetResetTime: 'Temps',
      pickupBoxKey: 'Clé de boîte de retrait',
      pickupBoxDeviceId: "ID d'appareil de boîte de retrait",
      pickupBoxAppId: "ID d'application de boîte de retrait",
      pickupBoxCredentials: 'Identifiants de la boîte de retrait',
      id: 'Id',
      apiGateway: 'Passerelle API',
      apiKey: 'Clé API',
      apiSecret: 'Api Secret',
      apiUrl: 'Api Url',
      profileId: 'ID de profil',
      establishmentId: "ID d'établissement",
      dataTransMerchantId: 'ID marchand DataTrans',
      dataTransMerchantPassword: 'Mot de passe marchand DataTrans',
      dataTransMerchantWebhookKey: 'Clé de webhook marchand DataTrans',
      dataTransGoogleMerchantId: 'ID marchand Google',
      pspId: 'ID PSP',
      host: 'Hôte',
      sdCredentials: 'Identifiants SD',
      orderOffsetHint:
        "Veuillez indiquer combien de minutes après l'ouverture doivent passer avant d'accepter la première commande, 60 = 1 heure",
      lastOrderOffsetHint:
        'Veuillez indiquer combien de minutes avant la fermeture une commande peut être passée, 60 = 1 heure',
      preorderOffset: 'Décalage minimum de précommande',
      preorderOffsetHint:
        "Veuillez indiquer combien de minutes après l'ouverture doivent passer avant d'accepter la première commande, 60 = 1 heure",
      firstPreorderOffset: 'Décalage de précommande le plus tôt',
      lastPreorderOffset: 'Décalage de précommande le plus tard',
      lastPreorderOffsetHint:
        'Veuillez indiquer combien de minutes avant la fermeture une commande peut être passée, 60 = 1 heure',
      phoneHint: 'ex: +4912345678901',
      autoDeclineTime: "Temps d'annulation",
      uploadedFile: 'Fichier téléchargé',
      terms: 'Conditions générales',
      imprint: 'Mentions légales',
      privacy: 'Confidentialité',
      accessibility: 'Accessibilité',
      other: 'Autre document',
      registerCourt: "Tribunal d'enregistrement",
      registerNumber: "Numéro d'enregistrement",
      chiefExecutives: 'Dirigeant(s) principal(aux)',
      sepaMandateRef: 'Référence du mandat SEPA',
      sepaMandateRegistrationLink: "Lien d'enregistrement du mandat SEPA",
      sepaMandateRegistrationError: "Erreur d'enregistrement du mandat SEPA",
      piggyLoyaltyEnabled: 'Fidélité Piggy activée',
      webAppSlug: "Slug de l'application web",
      takeAway: 'À emporter',
      delivery: 'Livraison',
      foodspot: 'Foodspot',
      terminalUsername: "Nom d'utilisateur terminal",
      terminalPassword: 'Mot de passe terminal',
      mobileUsername: "Nom d'utilisateur mobile",
      mobilePassword: 'Mot de passe mobile',
      deliveryProviders: {
        orderLord: 'OrderLord',
        rushHour: 'Rush Hour',
        woltDrive: 'Wolt Drive',
        ultraDispo: 'Ultra Dispo',
        orderLordEnabled: 'Activé',
        orderLordActive: "OrderLord disponible (défini par l'administrateur)",
        orderLordToken: 'Jeton API OrderLord',
        orderLordPassword: 'Mot de passe API OrderLord',
        rushhourIntegration: 'Intégration Rush Hour activée',
        rushhourToken: 'Jeton Rush Hour',
        woltdriveToken: 'Jeton Wolt Drive',
        woltdriveMerchantId: 'ID Wolt Drive',
        smoothrDispatchEnabled: 'Expédition Smoothr',
        customerId: 'ID client',
        clientId: 'ID client',
        clientSecret: 'Secret client',
        batchSize: 'Taille du lot',
        deliveryOffsetCalculationMode: 'Mode de calcul du délai de livraison',
        deliveryOffsetCalculationModeLegacy: 'Hérité',
        deliveryOffsetCalculationModeVersionJuly2026: 'Version juillet 2026',
        refundEmails: 'E-mails de remboursement',
        enabled: 'Activé',
        merchantUsername: "Nom d'utilisateur du marchand",
        merchantPassword: 'Mot de passe du marchand',
        deliverableOrderTypes: 'Types de commande livrable',
        pinVerificationEnabled: 'Vérification par code PIN activée',
        pinVerificationMinimumAmount: 'Prix total minimum de commande pour la vérification par code PIN',
        dishbee: 'Dishbee',
        kurierzentrale: 'Kurierzentrale',
        botToken: 'Jeton du bot',
        channelId: 'ID du canal',
        username: "Nom d'utilisateur",
        password: 'Mot de passe',
        partnerId: 'ID du partenaire',
        locationReferenceId: 'Référence du site',
        averageDeliveryTime: 'Temps de livraison moyen',
        deliveryFailureRecipientEmails: "E-mails des destinataires en cas d'echec de livraison",
      },
      externalOrderProviders: {
        useExternalProviders: 'Utiliser des fournisseurs de commande externes',
        generalSettings: 'Paramètres généraux',
        skipExternalOrderValidation: 'Accepter les commandes avec des articles inactifs',
        skipExternalOrderValidationNotice:
          "Lorsqu'elle est activée, accepte les commandes des fournisseurs, même si la commande contient des articles DÉSACTIVÉS dans Smoothr.",
        sendOrdersWithInactiveArticlesToPos: 'Envoyer la commande avec des articles inactifs au PDV',
        orderDirectEnabled: 'OrderDirect activé',
        orderDirectImprint: 'Mentions légales OrderDirect',
        woltEnabled: 'Wolt activé',
        autoSyncTimesEnabled: 'Synchroniser les heures automatiquement',
        enableAutoOrderReady: 'Activer le statut de commande prête automatiquement',
        connectWolt: 'Rejoindre Wolt',
        connectUberEats: 'Rejoindre Uber Eats',
        syncAllFoodcards: 'Synchroniser toutes les cartes alimentaires',
        uberEatsEnabled: 'Uber Eats activé',
        jetEnabled: 'JET activé',
        deliverooEnabled: 'Deliveroo activé',
        storeId: 'ID du magasin',
        siteId: 'ID du site',
        brandId: 'ID de la marque',
        coverPhotoUrl: 'Image du menu',
        menuDescription: 'Description du menu',
        apiVersion: "Version de l'API",
        venue: 'ID du restaurant',
        username: "Nom d'utilisateur",
        password: 'Mot de passe',
        orderApiKey: 'Clé API de commande',
        apiKey: 'Clé API',
        syncFoodcard: 'Synchroniser la carte alimentaire',
        syncStatus: 'Statut de synchronisation du restaurant',
        syncOpeningHours: "Synchroniser les heures d'ouverture",
        foodcardSyncStarted: "La synchronisation du menu a été ajoutée à la file d'attente et commencera bientôt.",
        online: 'Le restaurant a été activé. Les commandes sont maintenant possibles',
        offline: 'Le restaurant a été désactivé. Les commandes ne sont pas possibles.',
        openingHoursSynched: "Les heures d'ouverture ont été synchronisées.",
        preparationTime: 'Temps de préparation moyen',
        deliveryTime: 'Temps de livraison moyen',
        autoAccept: 'Accepter automatiquement les commandes',
        autoAcceptByPos: 'Accepter automatiquement (PDV)',
        ocuFlowEnabled: 'Flux OCU',
        articleAvailabilitySyncEnabled: 'Synchroniser la disponibilité des articles',
        clientId: 'ID client',
        clientSecret: 'Secret client',
        checkoutIntegrationDelayingEnabled: "Retarder l'intégration de paiement (PDV)",
        autoSyncEnabled: 'Synchroniser automatiquement la carte alimentaire',
        enforceDeliveryMenuHours: 'Appliquer les heures du menu de livraison',
        providerTabletEnabled: 'Tablette du fournisseur activée',
        ignorePosStatusEvents: 'Ignorer les événements de statut PDV',
        dispatchMode: 'Mode de livraison',
        articleDependencyMode: 'Mode de dépendance des articles',
        providerVenueModes: {
          provider_delivery: 'Livraison par le fournisseur',
          own_delivery: 'Livraison par le restaurant',
        },
        articleDependencyModes: {
          ignore_article: "Ignorer l'article principal",
          ignore_dependency_only: "Ajouter l'article, mais ignorer les dépendances",
        },
        refreshAlert: 'Veuillez actualiser la page pour voir les changements',
        shouldReplaceDeposit: "Remplacer l'article de dépôt",
        visible: 'Visible',
        defaultPreparationTime: 'Temps de préparation par défaut',
        defaultPreparationTimeHint:
          'Si la réinitialisation automatique est activée, le temps de préparation sera automatiquement fixé à cette valeur après un certain laps de temps.',
      },
      invoiceReceiver: {
        email: "Adresse e-mail alternative du destinataire de la facture (sinon l'e-mail de contact sera utilisé)",
      },
      deliveryFeesAfterCreation:
        'Les frais de livraison peuvent être spécifiés dans les paramètres du restaurant après la création.',
      sanifairEnabled: 'Intégration Sanifair',
      sanifairBingoEnabled: 'Sanifair Bingo actif',
      sanifairLocationId: 'ID de lieu Sanifair',
      sanifairDeviceId: "ID d'appareil Sanifair",
      addExternalDelivery: 'Ajouter un service de livraison externe',
      deleteExternalDelivery: 'Supprimer',
      customerSupportMail: {
        email: 'E-mail',
      },
      sandboxUrl: 'URL Sandbox',
      clientId: 'ID client',
      clientSecret: 'Secret client',
      username: "Nom d'utilisateur",
      password: 'Mot de passe',
      recordType: "Type d'enregistrement",
      channelPc: 'Canal PC',
      enabled: 'Activé',
      ccvApikey: 'Clé API CCV',
      comoApiKey: 'Clé API Como',
      installationId: "ID d'installation",
      locationId: 'ID de lieu',
      authenticationToken: "Jeton d'authentification",
      defaultTemplate: 'Modèle par défaut',
      delfiUrl: 'URL Delfi',
      disabledFields: 'Champs désactivés',
      disabledFieldsList: {
        allergens: 'Allergènes',
        template: 'Modèle',
        pictograms: 'Pictogrammes',
        description_translations: 'Traductions de la description',
        disclamer_translations: 'Traductions de la mention légale',
      },
      syncMenu: 'Synchroniser le menu',
      activateForm: 'Activer le formulaire',
      boardingPassVerificationEnabled: "Valider la carte d'embarquement",
      paxControlScanningPositionId: 'ID de position de numérisation Pax Control',
      costCenter: 'Centre de coût',
      ecrNumber: 'Numéro ECR',
      account: 'Compte',
      offsetAccount: 'Compte de contrepartie',
      actions: {
        addPaymentMapping: 'Ajouter une correspondance de méthode de paiement',
        removePaymentMapping: 'Supprimer la correspondance de méthode de paiement',
        addOrderTypeMapping: 'Ajouter une correspondance de type de commande',
        removeOrderTypeMapping: 'Supprimer la correspondance de type de commande',
      },
      paymentMethodMappings: 'Correspondance des méthodes de paiement',
      orderTypeMappings: 'Correspondance des types de commande',
      checkoutIntegrationProps: {
        serviceUrl: 'URL du service',
        orgname: "Nom de l'organisation",
        orgShortName: "Nom court de l'organisation",
        locRef: 'Réf. de lieu',
        rvcRef: 'Réf. de centre de revenus',
        username: "Nom d'utilisateur",
        password: 'Mot de passe',
        clientId: 'ID client',
        authUrl: "URL d'authentification",
        version: 'Version',
        checkHandling: 'Gestion de la caisse',
        defaultEmployee: 'Employé par défaut',
        defaultOrderType: 'Type de commande par défaut',
        orderTypeInside: 'Type de commande sur place',
        orderTypeTakeAway: 'Type de commande à emporter',
        orderTypeDelivery: 'Type de commande livraison',
        orderTypeFoodspot: 'Type de commande Foodspot',
        serviceChargeTip: 'Pourboire de service',
        serviceChargeDeliveryFee: 'Frais de livraison de service',
        orderTypeInsideTerminal: 'Type de commande sur place terminal',
        orderTypeTakeAwayTerminal: 'Type de commande à emporter terminal',
        orderTypeDeliveryTerminal: 'Type de commande livraison terminal',
        firetimeOffset: 'Décalage de déclenchement',
        averageDeliveryTime: 'Temps de livraison moyen',
        useExternalId: "Utiliser l'ID externe",
        autoSyncEnabled: 'Activer la synchronisation automatique',
        priceAutoSyncEnabled: 'Activer la synchronisation automatique des prix',
        useSanifairAsTender: 'Utiliser Sanifair comme moyen de paiement',
        useTableAsEmployee: 'Utiliser la table comme employé',
        useCodeAsOrderCode: 'Utiliser le code comme code de commande',
        useSecondaryCodeAsOrdercode: 'Utiliser le code secondaire comme code de commande',
        retryOnApiCrash: "Réessayer en cas de panne de l'API",
        skipRetryOnPosError: "Ne pas réessayer en cas d'erreur PDV",
        useZeroCode: 'Utiliser le code zéro',
        orderChannelRef: 'Réf. du canal de commande',
        orderChannelRefMapping: 'Correspondance de la réf. du canal de commande',
        addOrderChannelRefMapping: 'Ajouter une correspondance de la réf. du canal de commande',
        firetimeEnabled: 'Déclenchement activé',
        sendOrderNotes: 'Envoyer les notes de commande',
        hideTableName: 'Masquer le nom de la table',
        healthcheckEnabled: 'Contrôle de santé activé',
        multiConventional: 'Multi conventionnel',
        cancelTenderType: 'Annuler le type de commande',
        cashPaymentCancelTimeout: "Délai d'annulation du paiement en espèces",
        useCancelTenderType: "Utiliser le type d'annulation de commande",
        excludedTenders: 'Moyens de paiement exclus (du Multi-Conventionnel)',
        multiConventionalRevenueCenters: 'Centres de revenus multi conventionnels',
        multiConventionalOrderProfiles: 'Profils de commande multi conventionnels',
        sentBoardingPassEnabled: "Carte d'embarquement envoyée",
        sentRbiLoyaltyEnabled: 'Fidélité RBI envoyée activée',
        recalculatePayment: 'Recalculer le paiement',
        replaceCashOrdersByVirtualOrders: 'Remplacer les commandes en espèces par des commandes virtuelles',
        deepHierarchyOnMultiConventionalOrders: 'Hiérarchie profonde sur les commandes multi conventionnelles',
        priceSequence: 'Séquence de prix',
        orderProfile: 'Profil de commande',
        taxRate: 'Taux de taxe',
        sku: 'SKU',
        value: 'Valeur',
        prices: 'Prix',
        zeroPaymentMapping: 'Correspondance des méthodes de paiement (Paiement zéro)',
        postfinanceMapping: 'Correspondance des méthodes de paiement (PostFinance)',
        preparationTime: 'Temps de préparation moyen',
        deliveryTime: 'Temps de livraison moyen',
        piggyPrepaidBalance: 'Solde prépayé Piggy',
        piggyGiftCard: 'Cartes-cadeaux Piggy',
        allowManualBooking: 'Autoriser la réservation manuelle',
        useTerminalName: 'Utiliser le nom du terminal',
        sendTableNumberAsOrderNote: 'Envoyer le numéro de table comme note de commande',
        financialApiEnabled: 'Reçus activés',
        discountArticles: 'Articles de remise',
        depositArticles: 'Articles de dépôt',
        deposit: 'Dépôt',
        discountAsArticlesEnabled: "Envoyer la remise sous forme d'article",
        revenueCenter: 'Centre de revenus',
        terminalRevenueCenters: 'Centres de revenus terminal',
        preOrderRevenueCenters: 'Centres de revenus de précommande',
        externalOrderProviderRevenueCenters: 'Centres de revenus des fournisseurs de commande externes',
        addTerminalRevenueCenter: 'Ajouter un centre de revenus terminal',
        addPreOrderRevenueCenter: 'Ajouter un centre de revenus de précommande',
        addExternalOrderProviderRevenueCenter: 'Ajouter un centre de revenus de fournisseur de commande externe',
        externalOrderProviderType: 'Type de fournisseur de commande externe',
        cncEnabled: 'CNC activé',
        webhookEnabled: 'Webhooks Simphony activés',
        cncAuthUrl: "URL d'authentification CNC",
        cncUsername: "Nom d'utilisateur CNC",
        cncPassword: 'Mot de passe CNC',
        cncClientId: 'ID client CNC',
        cncApiUrl: "URL de l'API CNC",
        cncHierUnit: "ID d'unité hiérarchique CNC",
        useNotesAsOrderCodeEnabled: 'Utiliser les notes comme code de commande',
        default: 'Par défaut',
        paymentMethod: 'Méthode de paiement',
        revelType: 'Revel Type',
        fullcircleLocationId: 'fullcircle location ID',
        fullcircleRegisterId: 'fullcircle register ID (optional)',
        fullcircleRegisterRef: 'fullcircle register alias (optional)',
        fullcircleMethod: 'fullcircle payment method code',
        ncrType: 'NCR Type',
        useSimphonyPrice: 'Utiliser les prix de Simphony',
        disabledFields: 'Champs de charge utile désactivés',
        stockMode: 'Mode de stock',
        nepOrganization: 'Nep Organisation',
        nepEnterpriseUnit: 'Nep Enterprise Unit',
        secretKey: 'Secret Key',
        sharedKey: 'Shared Key',
        integrationKey: "Key d'intégration",
        license: 'Licence',
        tipPaymentMethod: 'Méthode de paiement du pourboire',
        arcavisId: 'Arcavis ID',
        locationId: 'ID de lieu',
        environment: 'Environnement',
        webhookSecret: 'Webhook Secret',
        orderbirdMethod: 'Méthode Orderbird',
      },
      addTip: 'Ajouter un pourboire',
      removeTip: 'Supprimer le pourboire',
      addDefaultTip: 'Ajouter un pourboire par défaut',
      tipEnabled: 'Pourboire activé',
      orderType: 'Type de commande',
      subOrderTypes: 'Sous-types de commande',
      subOrderType: 'Sous-type de commande',
      defaultTips: 'Pourboires par défaut',
      defaultTipValue: 'Valeur du pourboire par défaut',
      defaultTipType: 'Type de pourboire par défaut',
      defaultTip: 'Pourboire par défaut',
      panicReason: 'Raison de la panique',
      accountName: 'Nom du compte',
      tipTypes: {
        absolute: 'Valeur fixe',
        relative: 'Pourcentage',
        any: 'Toute valeur',
      },
      salesforcePromotionsEnabled: 'Promotions Salesforce activées',
      voucherify: {
        enabled: 'Activé',
        appId: "ID d'application",
        appKey: "Clé d'application",
        loyaltyCampaign: 'Campagne de fidélité',
      },
      grubtech: {
        enabled: 'Activé',
        storeId: 'Store ID',
        apiKey: 'API Key',
        partnerId: 'Partner ID',
      },
      finances: {
        customerNumber: 'Numéro de client',
        licences: 'Licences',
        sot: 'Quantité de SOT',
        sco: 'Quantité de SCO',
        operator: 'Quantité de Opérateur-Licenses',
        pickup: 'Quantité de PickUp-Licenses',
        driveIn: 'Quantité de DriveIn-Licenses',
        menuboard: 'Quantité de Menuboard-Licenses',
        custom: 'Personnalisé',
        hardware: 'Hardware/Appareils',
        addHardware: 'Ajouter du Hardware/Appareils',
        removeHardware: 'Supprimer le Hardware/Appareils',
        count: 'Nombre',
        rentStartedAt: 'Location commencée le',
        rentEndedAt: 'Location terminée le',
      },
    },
    legal: {
      useTemplate: 'Utiliser le modèle',
      termsHtml: '',
      imprintHtml: '',
      privacyHtml: '',
      accessibilityHtml: '',
      otherHtml: '',
    },
    infoOpeningHours: {
      openingHours: `- Vous pouvez ajouter des heures d'ouverture pour des jours individuels en cliquant sur un jour et en choisissant un créneau horaire. Pour enregistrer les heures d'ouverture, cliquez sur l'icône de l'horloge.<br />
      - En sélectionnant plusieurs jours de la semaine à la fois, vous pouvez ajouter les mêmes heures d'ouverture pour ces jours. Pour enregistrer les heures d'ouverture, cliquez sur l'icône de l'horloge.<br />
      - Vous pouvez également ajouter plusieurs heures d'ouverture pour un jour en répétant les étapes pour définir des heures d'ouverture individuelles.`,
      specialOpeningHours: `- Si vous souhaitez que votre restaurant ait des heures d'ouverture spéciales un jour spécifique (par exemple, les jours fériés), vous pouvez les ajouter ici. Choisissez simplement une date et ajoutez les heures spéciales.<br />
      - Si vous souhaitez fermer votre restaurant à une date spécifique, vous pouvez choisir le jour et cocher la case "Restaurant fermé". Le restaurant sera fermé toute la journée.<br />
      - Sinon, si vous devez fermer votre restaurant pendant une durée spécifique un jour spécial, vous pouvez choisir la date et un créneau horaire, puis cocher la case "Restaurant fermé". Le restaurant sera fermé pour ce créneau horaire spécifique.<br />
      - Assurez-vous d'avoir d'abord ajouté des heures d'ouverture. Sinon, vos heures d'ouverture spéciales ne seront pas enregistrées.`,
    },
    infoDeliveryHours: {
      deliveryHours: `- Vous pouvez ajouter des heures de livraison pour des jours individuels en cliquant sur un jour et en choisissant un créneau horaire. Pour enregistrer les heures de livraison, cliquez sur l'icône de l'horloge.<br />
      - En sélectionnant plusieurs jours de la semaine à la fois, vous pouvez ajouter les mêmes heures de livraison pour ces jours. Pour enregistrer les heures de livraison, cliquez sur l'icône de l'horloge.<br />
      - Vous pouvez également ajouter plusieurs heures de livraison pour un jour en répétant les étapes pour définir des heures de livraison individuelles.`,
      specialDeliveryHours: `- Si vous souhaitez que votre restaurant ait des heures de livraison spéciales un jour spécifique (par exemple, les jours fériés), vous pouvez les ajouter ici. Choisissez simplement une date et ajoutez les heures spéciales.<br />
      - Si vous souhaitez fermer votre restaurant pour la livraison à une date spécifique, vous pouvez choisir le jour et cocher la case "Restaurant fermé". Le restaurant sera fermé pour la livraison toute la journée.<br />
      - Sinon, si vous devez fermer votre restaurant pour la livraison pendant une durée spécifique un jour spécial, vous pouvez choisir la date et un créneau horaire, puis cocher la case "Restaurant fermé". Le restaurant sera fermé pour la livraison pour ce créneau horaire spécifique.<br />
      - Assurez-vous d'avoir d'abord ajouté des heures de livraison. Sinon, vos heures de livraison spéciales ne seront pas enregistrées.`,
    },
  },
  analytic: {
    from: 'De',
    to: 'À',
  },
  stats: {
    index: 'Gérer les statistiques',
    indexAnalytics: "Gérer l'analytique",
    totalNumberOfOrders: 'Nombre de commandes',
    avgOrdersPerDay: 'Ø Nombre de commandes/jour',
    avgAmount: 'Ø Valeur de commande',
    totalAmount: 'Somme totale',
    totalSoldArticles: 'Articles vendus',
    highestDaysSale: "Chiffre d'affaires quotidien le plus élevé",
    totalPreCheckouts: 'Prépaiements confirmés',
    paymentMethod: 'Méthode de paiement',
    avgOrderDuration: 'Ø Durée de commande',
    totalTimeouts: "Nombre de délais d'expiration",
    monthSales: 'Ventes mensuelles',
    selectVenue: "Sélectionnez d'abord un restaurant",
    customerGroup: 'Groupe de clients',
    ui: {
      country: 'Pays',
      search: 'Rechercher',
      bestSold: 'Meilleures ventes',
      worstSold: 'Moins vendus',
      ordersView: 'Vue des commandes',
      articleView: 'Vue des articles',
      quantity: 'Quantité',
      orders: 'Commandes',
      price: 'Prix',
      refresh: 'Actualiser',
      debug: 'TEST',
      prod: 'LIVE',
      customerGroup: 'Groupe de clients',
      flavor: 'Sélectionner la(les) saveur(s)',
      status: 'Sélectionner le(s) statut(s)',
      table: 'Sélectionner le(s) type(s)',
      type: 'Sélectionner la(les) table(s)',
      platforms: 'Sélectionner la(les) plateforme(s)',
      label: "Sélectionner l'étiquette",
      externalOrderProvider: 'Sélectionner le fournisseur',
      searchId: "Rechercher l'ID",
      searchCode: 'Rechercher le code',
      number: 'Numéro',
      copyOrderId: "Copier l'ID de commande",
      orderId: 'ID de commande',
      note: 'Note',
      today: "Aujourd'hui",
      yesterday: 'Hier',
      monthly: 'Mensuel',
      daily: 'Quotidien',
      showReceipts: 'Afficher les reçus',
      showLogs: 'Afficher les journaux',
      logs: 'Journaux',
      more: 'plus',
      deliveryFee: 'Frais de livraison',
    },
    table: {
      order: 'Commande',
      paymentMethod: 'Méthode de paiement',
      date: 'Date',
      orderDate: 'Date de commande',
      orderTime: 'Heure de commande',
      customer: 'Client',
      time: 'Heure',
      qty: 'Quantité',
      venue: 'Restaurant',
      itemName: 'Articles',
      allCat: 'Toutes les catégories',
      cat: 'Catégories',
      type: 'Type de commande',
      subType: 'Sous-type de commande',
      status: 'Statut',
      table: 'Table',
      price: 'Prix/Article',
      total: 'Total',
      name: 'Nom',
      note: 'Note',
      secondaryCode: 'Code secondaire',
      dndCompanyCode: 'Code entreprise',
      retry: 'Réessayer',
      createdAt: 'Créé',
      level: 'Niveau',
      source: 'Source',
      logs: 'Journaux',
      provider: 'Fournisseur',
      loyaltyArticles: 'Articles de fidélité',
      orderedArticles: 'Articles commandés',
      clientMeta: 'Métadonnées client',
      platform: 'Plateforme',
      device: 'Appareil',
      browser: 'Navigateur',
      appVersion: "Version de l'application",
      osVersion: "Version du système d'exploitation",
      externalOrderId: 'ID de commande externe',
      room: 'Salle',
      pickupStation: 'Station de retrait',
      checkoutIntegrationStatus: 'Statut PDV',
      promoCode: 'Code promotionnel',
    },
    platforms: {
      web: 'Web',
      ios: 'iOS',
      android: 'Android',
    },
  },
  sales: {
    index: 'Ventes de produits',
    ui: {
      category: 'Sélectionner la(les) catégorie(s)',
      item: 'Sélectionner le(s) article(s)',
      label: "Sélectionner l'étiquette du restaurant",
      dateType: 'Type de date',
      createdAt: 'Date de commande',
      orderAt: 'Date de retrait/livraison',
    },
    table: {
      name: 'Nom',
      sales: 'Ventes',
      total: 'Total',
      cat: 'Catégorie',
    },
  },
  salesOverview: {
    index: 'Aperçu des ventes',
    filter: {
      customerGroup: 'Groupe de clients',
      flavor: 'Saveur',
    },
    table: {
      venue: 'Restaurant',
      webApp: 'Application web',
      terminal: 'Terminal',
      terminalTakeaway: 'Terminal à emporter',
      terminalInside: 'Terminal sur place',
      wolt: 'Wolt',
      uberEats: 'Uber Eats',
      jet: 'Jet',
      pickup: 'Retrait',
      delivery: 'Livraison',
      total: 'Total',
      orders: 'Commandes',
      amount: 'Montant',
      totalOrders: 'Commandes totales',
      totalAmount: 'Montant total',
      inside: 'Boutique en ligne sur place',
      foodspot: 'Foodspot',
      orderAtTable: 'Commander à table',
    },
  },
  billing: {
    index: 'Facturation',
    billing: 'Exporter la facturation',
    orderCsv:
      "Exporter les commandes (L'exportation sera envoyée à l'e-mail avec lequel vous êtes actuellement connecté.)",
    foodspotExport:
      "Exporter Foodspot (L'exportation sera envoyée à l'e-mail avec lequel vous êtes actuellement connecté.)",
    paymentMethodCsv:
      "Exporter les commandes par méthode de paiement (L'exportation sera envoyée à l'e-mail avec lequel vous êtes actuellement connecté.)",
    salesCsv:
      "Exporter les ventes (L'exportation sera envoyée à l'e-mail avec lequel vous êtes actuellement connecté.)",
    salesGroup:
      "Exporter le groupe de ventes (L'exportation sera envoyée à l'e-mail avec lequel vous êtes actuellement connecté.)",
    summary: 'Exporter le résumé de facturation',
    summaryVenueRequired: 'Sélectionnez un établissement pour le récapitulatif de facture.',
    plainSummary: 'Exporter le résumé de facturation simple',
    datev: 'Exporter Datev',
    articlesOverview: 'Type de commande',
    wallet: 'Exporter les portefeuilles',
    form: {
      venue: 'Restaurant',
      company: 'Entreprise',
      label: 'Étiquette de restaurant',
      flavor: 'Saveur',
      customerGroup: 'Groupe de clients',
      withoutTags: 'Ne pas filtrer les étiquettes "vides"',
      showExpanded: 'Afficher les données étendues',
      subscribedToMailing: 'Abonné à la newsletter',
      filterEmptyByMail: 'Filtrer les vides par e-mail',
      typeExportFile: 'Type de fichier exporté',
      requiredField: "Veuillez choisir l'un des champs",
    },
  },
  userExport: {
    index: "Exportation d'utilisateurs",
    userExport: "Exporter l'utilisateur",
    userCsv: 'Exporter les utilisateurs',
    userWithNewsletterCsv: 'Exporter les utilisateurs avec newsletter',
    form: {},
  },
  activityLogExport: {
    index: "Exportation des journaux d'activité",
    activityLogCsv: 'Exporter les journaux',
    form: {
      type: 'Type',
      venue: 'Restaurant',
      typeExportFile: 'Type de fichier exporté',
    },
  },
  sepa: {
    index: 'SEPA',
    title: 'Paramètres SEPA',
    mandate: 'Mandat',
    sepaMandate: 'Mandat SEPA',
    venues: 'Restaurants',
    createSepa: 'Créer un nouveau mandat SEPA',
    debit: 'Débit SEPA',
    payLast: 'Payer les factures des 30 derniers jours',
    notification: {
      cancelError: "Erreur lors de l'annulation du mandat SEPA",
      cancelWarning:
        'Êtes-vous sûr de vouloir annuler ce mandat SEPA ? Il sera supprimé et ne pourra plus être utilisé pour les paiements.',
      createError: "Impossible de créer un nouveau lien d'enregistrement de mandat SEPA",
      createWarning:
        "Êtes-vous sûr de vouloir créer un nouveau lien d'enregistrement de mandat SEPA ? Les mandats SEPA existants pour les restaurants sélectionnés seront supprimés et ne pourront plus être utilisés pour les paiements.",
      payWarning:
        'Un mandat SEPA existe pour ce restaurant. Voulez-vous créer un nouveau paiement SEPA pour cette transaction ?',
      payLastTransactionsWarning:
        'Êtes-vous sûr de vouloir mandater des paiements pour toutes les factures des 30 derniers jours pour ces restaurants ? Ensuite, les paiements individuels peuvent être annulés dans les 2 jours. Dans ce cas, veuillez contacter immédiatement le support.',
      payLastTransactionsSuccess:
        "Factures des 30 derniers jours payées. Vous recevrez un e-mail pour chaque paiement mandaté. Veuillez contacter le support dans les 2 jours si vous souhaitez annuler l'un des paiements.",
    },
    form: {
      merchantId: 'ID marchand',
      venues: 'Restaurants',
      merchantName: 'Nom du marchand',
      payLastTransactionsAfterCreate: 'Payer les factures ouvertes des 30 derniers jours *',
      payLastTransactionsAfterCreateHint:
        "Tous les montants de factures ouvertes des 30 derniers jours seront débités par notre système après la création du mandat SEPA. Vous recevrez un e-mail pour chaque paiement mandaté dans les prochaines heures. Veuillez contacter le support dans les 2 jours si vous souhaitez annuler l'un de ces paiements.",
      sepaMandateRef: 'Référence du mandat SEPA',
      sepaMandateRegistrationLink: "Lien d'enregistrement du mandat SEPA",
      sepaMandateRegistrationError: "Erreur d'enregistrement du mandat SEPA",
    },
  },
  productCombos: {
    index: 'Combinaisons de produits',
    overview: "Vue d'ensemble",
  },
  tips: {
    terminal: 'Terminal',
    webApp: 'Application web',
    inside: 'Sur place',
  },
  promo: {
    index: 'Gérer les codes promotionnels',
    create: 'Créer un nouveau code promotionnel',
    edit: 'Modifier le code promotionnel',
    exportCsv: 'Exporter',
    exportSummary: 'Exporter le résumé',
    exportCount: "Exporter le résumé d'activation",
    overviewCsv: 'Exporter les codes promotionnels',
    exportTeedeliZip: 'Exporter les codes promotionnels Teedeli (*.zip)',
    exportGeneralOverview: "Exporter l'aperçu général",
    overview: "Vue d'ensemble",
    add: 'Ajouter un code promotionnel',
    addTeedeli: 'Ajouter un code promotionnel Teedeli',
    addMultiple: 'Ajouter plusieurs codes promotionnels',
    disableCodes: 'Désactiver les codes',
    syncPiggyVouchers: 'Synchroniser les bons Piggy',
    syncPiggyVouchersSuccess: 'Bons Piggy synchronisés avec succès.',
    syncPiggyVouchersError: 'Erreur lors de la synchronisation des bons Piggy.',
    disableHint: "Veuillez d'abord sélectionner un restaurant",
    notification: {
      disableSuccess: 'Codes promotionnels désactivés avec succès.',
    },
    types: {
      absolute: 'Valeur absolue',
      relative: 'Valeur relative',
      bogo: 'BOGO',
      deliveryFee: 'Pas de frais de livraison',
      reward: 'Récompense',
      giftCard: 'Carte-cadeau',
      freeArticle: 'Article gratuit',
      void: 'Annulation',
      absoluteArticle: 'Remise sur article (absolue) - OBSOLÈTE',
      relativeArticle: 'Remise sur article (relative) - OBSOLÈTE',
      singleAbsoluteArticle: 'Remise sur article (absolue)',
      singleRelativeArticle: 'Remise sur article (relative)',
      multipleAbsoluteArticle: 'Remise sur plusieurs articles (absolue)',
      multipleRelativeArticle: 'Remise sur plusieurs articles (relative)',
      dependencyFreeArticle: 'Article gratuit dépendant',
      cheapestFreeArticle: 'Article le moins cher gratuit',
      cheapestHalfArticleDiscountRelative: 'Remise sur la moitié des articles',
      mostExpensiveArticleDiscountRelative: "Remise sur l'article le plus cher (relative)",
      teedeliPremium: 'Remise sur article (premium)',
      unlockArticles: 'Débloquer des articles',
      coupon: 'Coupon',
      multipleFreeArticles: 'Articles gratuits multiples',
    },
    table: {
      name: 'Nom',
      code: 'Code',
      customerGroup: 'Groupe de clients',
      mov: 'Valeur minimale de commande',
      from: 'Valable du',
      to: "Valable jusqu'au",
      disabled: 'Désactivé (Restaurant uniquement)',
      venues: 'Restaurants',
      type: 'Type',
      value: 'Valeur',
      active: 'Actif (Global)',
      disabledBy: 'Désactivé par',
      countries: 'Pays',
      states: 'États',
      amount: 'Utilisation max.',
      unlimited: 'Illimité',
    },
    form: {
      offerPeriod: "Période d'offre",
      unlimitedTime: 'Durée illimitée',
      unlimitedAmount: 'Utilisation illimitée',
      lightspeedCode: 'Code Lightspeed',
      simphonyCode: 'Code Simphony',
      useCustomerRedemptionCodes: 'Codes promotionnels comme codes à usage unique',
      name: 'Nom',
      code: 'Code',
      description: 'Description',
      venue: 'Restaurant',
      valid: 'Valide',
      article: 'Article',
      generateAmount: 'Nombre à générer',
      label: 'Étiquette de restaurant',
      isMultipleApplicable: "Le client peut l'utiliser plusieurs fois",
      applyOnAnyQuantity: "Appliquer sur n'importe quelle quantité",
      customerGroup: 'Groupe de clients',
      countries: 'Pays',
      states: 'États/Régions',
      codes: 'Codes promotionnels',
      uploadGiftCards: 'Fichier CSV avec cartes-cadeaux',
      venues: 'Restaurants',
      type: 'Type',
      freeArticle: 'Article gratuit',
      bogoArticles: 'Articles possibles (le produit le moins cher du panier sera utilisé pour le bogo)',
      mov: 'Valeur minimale de commande',
      amount: 'Utilisation maximale',
      amountTeedeli: 'Nombre de codes promotionnels',
      amountUsesTeedeli: 'Utilisation max.',
      active: 'Actif',
      value: 'Valeur',
      discount: 'Remise',
      percent: 'Valeur (ex: 20% veuillez saisir 0.2)',
      standardAvailability: 'Disponible',
      insideAvailability: 'Disponible sur place',
      takeAwayAvailability: 'Disponible à emporter',
      deliveryAvailability: 'Disponible en livraison',
      preorderParkCollect: 'Disponible pour Park & Collect',
      preorderFoodspot: 'Disponible pour Foodspot',
      webAvailability: 'Disponible',
      isMaster: 'Est maître',
      generalPromoCode: 'Code promotionnel général',
      registrationRequired: 'Inscription requise',
      boundToUser: "Lié à l'utilisateur",
      usageFrequency: "Fréquence d'utilisation",
      minQuantity: 'Quantité minimale',
      maxQuantity: "Quantité maximale d'articles remisables",
      isAutomatic: 'Déclencher automatiquement',
      isPiggyVoucher: 'Piggy Voucher',
      banner: 'Bannière',
      discountableMainCategories: 'Catégories principales remboursables',
    },
    usageFrequency: {
      any: 'Toute',
      daily: 'Quotidienne',
      weekly: 'Hebdomadaire',
      monthly: 'Mensuelle',
    },
    tabs: {
      general: 'Général',
      availability: 'Disponibilité',
      images: 'Images',
      availableHours: 'Heures disponibles',
      banner: 'Bannière',
    },
    standardAvailability: 'Disponibilité standard',
    terminalAvailability: 'Disponibilité terminal',
    preorderAvailability: 'Disponibilité de précommande',
    webAvailability: 'Disponibilité web',
    weekdaysAvailability: 'Disponibilité des jours de la semaine',
    cateringAvailability: 'Disponibilité traiteur',
  },
  cupCode: {
    index: 'Gérer le code gobelet',
    create: 'Créer un nouveau code gobelet',
    edit: 'Modifier le code gobelet',
    overview: "Vue d'ensemble",
    add: 'Ajouter un code gobelet',
    downloadCodes: 'Exporter les codes',
    downloadQRCode: 'Télécharger les codes QR',
    action: 'Actions sur une plage de codes',
    form: {
      number: 'Numéro',
      venue: 'Restaurant',
      active: 'Actif',
      quantity: 'Nombre de codes à générer',
      startingFrom: 'Numéro de départ des codes',
      customerGroup: 'Sélectionner les groupes de clients',
      format: 'Sélectionner le format de fichier',
    },
    table: {
      number: 'Numéro',
      venue: 'Restaurant',
      customerGroup: 'Groupes de clients',
      quantity: 'Quantité',
      startingFrom: 'À partir de',
      active: 'Actif',
      qrCode: 'Code QR',
      createdAt: 'Créé',
    },
    filter: {
      customerGroup: 'Groupes de clients',
      active: 'Actif',
      numFrom: 'Numéro de',
      numTo: 'Numéro à',
    },
  },
  coupon: {
    index: 'Gérer le coupon (obsolète)',
    create: 'Créer un nouveau coupon',
    edit: 'Modifier le coupon',
    exportCsv: 'Exporter',
    exportSummary: 'Exporter le résumé',
    exportCount: "Exporter le résumé d'activation",
    overviewCsv: 'Exporter le coupon',
    overview: "Vue d'ensemble",
    add: 'Ajouter un coupon',
    addMultiple: 'Ajouter plusieurs coupons',
    disableCodes: 'Désactiver le coupon',
    disableHint: "Veuillez d'abord sélectionner un restaurant",
    notification: {
      disableSuccess: 'Coupon désactivé avec succès.',
    },
    form: {
      offerPeriod: "Période d'offre",
      lightspeedCode: 'Code Lightspeed',
      name: 'Nom',
      code: 'Code',
      venue: 'Restaurant',
      valid: 'Valide',
      article: 'Article',
      generateAmount: 'Nombre à générer',
      label: 'Étiquette de restaurant',
      isMultipleApplicable: "Le client peut l'utiliser plusieurs fois",
      applyOnAnyQuantity: "Appliquer sur n'importe quelle quantité",
      customerGroup: 'Groupe de clients',
      countries: 'Pays',
      states: 'États/Régions',
      codes: 'Coupon',
      uploadGiftCards: 'Fichier CSV avec cartes-cadeaux',
      venues: 'Restaurants',
      type: 'Type',
      freeArticle: 'Article gratuit',
      bogoArticles: 'Articles possibles (le produit le moins cher du panier sera utilisé pour le bogo)',
      mov: 'Valeur minimale de commande',
      amount: 'Utilisation maximale',
      active: 'Actif',
      value: 'Valeur',
      discount: 'Remise',
      percent: 'Valeur (ex: 20% veuillez saisir 0.2)',
      standardAvailability: 'Disponible',
      insideAvailability: 'Disponible sur place',
      takeAwayAvailability: 'Disponible à emporter',
      deliveryAvailability: 'Disponible en livraison',
      preorderParkCollect: 'Disponible pour Park & Collect',
      preorderFoodspot: 'Disponible pour Foodspot',
      webAvailability: 'Disponible',
      image: 'Image',
      banner: 'Bannière',
      usageFrequency: "Fréquence d'utilisation",
      redeemableAtCheckoutOnly: 'Échangeable',
    },
    types: {
      absolute: 'Valeur absolue',
      relative: 'Valeur relative',
      bogo: 'BOGO',
      deliveryFee: 'Pas de frais de livraison',
      reward: 'Récompense',
      giftCard: 'Carte-cadeau',
      freeArticle: 'Article gratuit',
      void: 'Annulation',
      absoluteArticle: 'Remise sur article (absolue)',
      relativeArticle: 'Remise sur article (relative)',
      plusOneFree: '1 + 1 gratuit',
    },
    usageFrequency: {
      any: 'Toute',
      daily: 'Quotidienne',
      weekly: 'Hebdomadaire',
      monthly: 'Mensuelle',
    },
    table: {
      name: 'Nom',
      code: 'Code',
      customerGroup: 'Groupe de clients',
      mov: 'Valeur minimale de commande',
      from: 'Valable du',
      to: "Valable jusqu'au",
      disabled: 'Désactivé (Restaurant uniquement)',
      venues: 'Restaurants',
      type: 'Type',
      value: 'Valeur',
      active: 'Actif (Global)',
      disabledBy: 'Désactivé par',
      countries: 'Pays',
      states: 'États',
      amount: 'Utilisation max.',
    },
    tabs: {
      general: 'Général',
      availability: 'Disponibilité',
      images: 'Images',
    },
    standardAvailability: 'Disponibilité standard',
    terminalAvailability: 'Disponibilité terminal',
    preorderAvailability: 'Disponibilité de précommande',
    webAvailability: 'Disponibilité web',
    weekdaysAvailability: 'Disponibilité des jours de la semaine',
    cateringAvailability: 'Disponibilité traiteur',
  },
  receipt: {
    index: 'Reçus',
    overview: "Vue d'ensemble",
    receipts: 'Reçus',
    endOfDayReceipts: 'Reçus de fin de journée',
    form: {
      flavor: 'Saveur de commande',
      venue: 'Restaurant',
    },
    table: {
      code: 'Code de commande',
      at: 'À',
      sum: 'Somme',
      endOfDay: 'Fin de journée',
      merchantReceipt: 'Reçu marchand',
      customerReceipt: 'Reçu client',
      posCheckoutReceipt: 'Reçu de paiement PDV',
      exportCustomer: 'Exporter le reçu client',
      exportMerchant: 'Exporter le reçu marchand',
      exportCombined: 'Exporter le reçu marchand et client',
      exportFull: 'Exporter les reçus',
      tableNumber: 'Numéro de table',
    },
  },
  eposJobs: {
    index: 'Travaux',
    overview: "Vue d'ensemble",
    form: {
      venue: 'Restaurant',
      status: 'Statut',
      requestId: 'ID de demande',
      success: 'Succès',
      failed: 'Échec',
      partiallyFailed: 'Partiellement échoué',
      pending: 'En attente',
      started: 'Démarré',
      sortByCreatedAt: 'Date de création la plus récente',
      oldestToNewest: 'Du plus ancien au plus récent',
      newestToOldest: 'Du plus récent au plus ancien',
    },
    table: {
      sapNumber: 'Numéro SAP',
      status: 'Statut',
      statusMessage: 'Message de statut',
      createdAt: 'Créé le',
      finalizedAt: 'Finalisé le',
      exportFull: 'Exporter les reçus',
      requestId: 'ID de demande',
      ID: 'ID des modifications',
      articleType: "Type d'article",
      itemId: "ID de l'article",
      price: 'Prix',
      taxInside: 'Taxe sur place',
      taxTakeaway: 'Taxe à emporter',
      visibility: 'Visibilité',
      oldValue: 'Ancienne valeur',
      newValue: 'Nouvelle valeur',
      priceRuleId: 'ID de règle de prix',
      effectiveDateTimestamp: "Horodatage de date d'effet",
      expirationDateTimestamp: "Horodatage de date d'expiration",
      priceRuleSet: 'Ensemble de règles de prix',
      statusCode: 'Code de statut',
      taxIdInside: 'ID de taxe sur place',
      taxIdTakeaway: 'ID de taxe à emporter',
      errorList: "Liste d'erreurs",
      errorId: "ID d'erreur",
      articleName: "Nom de l'article",
      negativeFlag: 'Indicateur négatif',
      exportRawRequest: 'Exporter la demande brute',
      exportChanges: 'Exporter les modifications',
    },
  },
  sanifairLogs: {
    index: 'Sanifair',
    overview: "Vue d'ensemble",
    form: {
      venue: 'Restaurant',
      status: 'Statut',
      search: 'Rechercher',
      actionTypes: "Types d'action",
    },
    table: {
      sanifairActionType: "Types d'action",
      order: 'Commande',
      responseTimeSanifair: 'Temps de réponse Sanifair',
      responseTimeSmoothr: 'Temps de réponse Smoothr',
      responseTimeTotal: 'Temps de réponse total',
      createdAt: 'Créé le',
      sanifairRequestReceivedAt: 'Demande Sanifair reçue le',
      sanifairResponseReceivedAt: 'Réponse Sanifair reçue le',
      smoothrRequestReceivedAt: 'Demande Smoothr reçue le',
      smoothrResponseReceivedAt: 'Réponse Smoothr reçue le',
    },
  },
  automatedReports: {
    index: 'Rapports automatisés',
    overview: "Vue d'ensemble",
    add: 'Ajouter un rapport automatisé',
    form: {
      type: 'Type',
      venue: 'Restaurant',
      customerGroup: 'Groupe de clients',
      flavor: 'Saveur',
      lang: 'Langue',
      frequency: 'Fréquence',
      venueLabels: 'Étiquettes de restaurant',
      lastExecuted: 'Dernière exécution',
      receiver: 'Destinataire',
      cc: 'CC',
      active: 'Actif',
    },
    tabs: {
      general: 'Général',
    },
    table: {
      type: 'Type',
      customerGroup: 'Groupe de clients',
      flavor: 'Saveur',
      frequency: 'Fréquence',
      venueLabels: 'Étiquettes de restaurant',
      lastExecuted: 'Dernière exécution',
      receiver: 'Destinataire',
      selectVenue: 'Veuillez sélectionner un restaurant',
      selectGroup: 'Veuillez sélectionner un groupe de clients',
    },
    types: {
      orders: 'Commandes',
      orderByPaymentMethod: 'Commande par méthode de paiement',
      sales: 'Ventes',
      pdfBillingShort: 'Facturation PDF courte',
      pdfBillingLong: 'Facturation PDF longue',
    },
    frequency: {
      daily: 'Quotidien',
      weekly: 'Hebdomadaire',
      monthly: 'Mensuel',
      yearly: 'Annuel',
    },
  },
  paypal: {
    index: 'PayPal',
    success: "L'autorisation PayPal a réussi",
    description:
      "L'autorisation PayPal a réussi. Après que nos employés aient vérifié l'état de votre compte, les paiements PayPal seront activés.",
  },
  validations: {
    eod_email_enable: "La liste doit contenir des e-mails valides avant d'activer ceci",
    list_of_emails: 'Votre e-mail doit être séparé par une virgule.',
    list_of_integer: 'Les moyens de paiement exclus doivent être séparés par une virgule.',
    numbers_with_comma_or_dot: 'Le champ {field} doit être un nombre.',
    quantity_number: 'Le nombre ne peut pas être plus grand.',
    quantity_number_less_100k: 'La différence ne peut pas dépasser 100 000 et être inférieure à 0',
    quantity_number_less_10k: 'La différence ne peut pas dépasser 10 000 et être inférieure à 0',
    unique_email: "L'e-mail est déjà utilisé",
    admin_smoothr_email: 'Les utilisateurs administrateurs doivent utiliser une adresse e-mail @smoothr.de.',
    readable_id: "L'ID court est déjà pris.",
    venue_label: "L'étiquette de restaurant existe déjà.",
    password:
      'Le mot de passe doit contenir une majuscule, un chiffre ou un caractère spécial et comporter au moins 8 caractères.',
    identifier:
      "L'identifiant doit contenir uniquement des lettres minuscules séparées par un seul trait de soulignement",
    date_before: 'Le champ {field} doit être avant {target}',
    time_before: 'Le champ {field} doit être avant {target}',
    unique_dependency: 'Le champ {field} est un doublon',
    smaller_eq_than: 'Le champ {field} doit être au maximum {target}.',
    smaller_than: 'Le champ {field} doit être inférieur à {target}.',
    greater_than: 'Le champ {field} doit être supérieur à {target}.',
    greater_eq_than: 'Le champ {field} doit être au moins {target}.',
    uppercase: 'Seules les lettres majuscules sont autorisées',
    price: 'Le champ {field} doit être un prix valide (ex: 1.99)',
    nutritional_value: 'Le champ {field} doit être une valeur nutritionnelle valide (ex: 1.99)',
    uniqueFile: 'Le média téléchargé ne peut pas être modifié. Veuillez créer une nouvelle étape.',
    time: "Le format de l'heure est HH:mm.",
    url: "Veuillez saisir un domaine valide sans http/https, juste le domaine et l'extension.",
    url_simple: 'Veuillez saisir une URL complète valide avec http/https',
    url_ios_android: 'Le champ {field} doit être une URL valide pour le {storeType} Store',
    loyalty_campaign: "Le champ {field} doit être une campagne valide commençant par 'camp_'",
    phone: 'Veuillez saisir un numéro de téléphone valide (ex: +4912345678901)',
    uniq_company_code: 'Ce code entreprise est déjà pris. Veuillez choisir un code différent.',
    iban: 'Format IBAN invalide. Veuillez saisir un IBAN correct.',
    vatNumber: {
      info: 'Numéro de TVA valide avec une longueur minimale de 5 requis',
      error:
        'Le numéro de TVA est invalide ou déjà utilisé par un autre utilisateur. Veuillez saisir un autre numéro de TVA ou contacter un administrateur pour résoudre le problème.',
    },
    vatNumberGermany: {
      info: "Numéro d'identification fiscale allemand valide avec une longueur minimale de 5 requis",
      error:
        "Le numéro d'identification fiscale allemand est invalide ou déjà utilisé par un autre utilisateur. Veuillez saisir un autre numéro de TVA ou contacter un administrateur pour résoudre le problème.",
    },
  },
  footer: {
    imprint: 'Mentions légales',
    terms: 'Politiques de données',
  },
  reporting: {
    index: 'Rapports',
    form: {
      type: 'Type',
      periodType: 'Période',
      label: 'Étiquette de restaurant',
      country: 'Pays',
      venue: 'Restaurant',
      flavor: 'Saveur',
      customerGroup: 'Groupe de clients',
    },
    periods: {
      daily: 'Jour',
      weekly: 'Semaine',
      monthly: 'Mois',
      total: 'Total',
    },
    types: {
      stores: 'Restaurant',
      products: 'Article',
      customers: 'Client',
    },
  },
  screensaver: {
    index: 'Écran de veille',
    add: 'Créer un écran de veille',
    mediaType: 'Type de média',
    duration: 'Durée',
    level: 'Niveau',
    preview: 'aperçu',
    title: "Étape d'écran de veille",
    hours: 'Heures',
    overview: "Vue d'ensemble",
    stepSavingInfo: 'Le média sera téléchargé dans un instant, veuillez patienter.',
    category: 'Catégorie',
    form: {
      name: 'Nom',
      customerGroup: 'Groupe de clients',
      linkedCustomerGroup: 'Groupe de clients lié',
      venues: 'Restaurants',
      openingHours: "Heures d'ouverture",
      file: 'Média',
      duration: 'Durée en secondes',
      level: 'Niveau',
      saveOrder: 'Enregistrer le nouvel ordre',
      changeOrder: "Changer l'ordre",
      slug: 'Slug',
      visible: 'Visible',
      category: 'Catégorie',
      articles: 'Articles',
    },
    tabs: {
      screensaver: 'Écran de veille',
      upsellArticles: 'Articles de vente incitative',
      steps: 'Étapes',
      info: "Vous ne pouvez ajouter des étapes qu'après avoir créé l'écran de veille",
    },
    table: {
      steps: "Nombre d'étapes",
    },
  },
  employeeNotification: {
    index: 'Notification employé',
    add: 'Créer une notification employé',
    form: {
      title: 'Titre',
      message: 'Message',
    },
  },
  loyaltyPrograms: {
    index: 'Programmes de fidélité',
    add: 'Créer un programme de fidélité',
    create: 'Créer un programme de fidélité',
    edit: 'Modifier les programmes de fidélité',
    overview: "Vue d'ensemble",
    general: 'Général',
    clientCredentials: 'Identifiants client',
    rbiCredentials: 'Identifiants RBI',
    form: {
      type: 'Type',
      customerGroup: 'Groupe de clients',
      apikey: 'Clé API',
      oauthId: 'ID OAuth',
      oauthSecret: 'Secret OAuth',
      operator: 'Opérateur',
      posType: 'Type de PDV',
      storeId: 'ID du magasin',
      supportingPos: 'Support du PDV',
      piggy: 'Piggy',
      como: 'Como',
      internal: 'Interne',
      rbi: 'RBI',
      shopUuid: 'UUID de la boutique',
    },
    table: {
      type: 'Type',
      customerGroup: 'Groupe de clients',
      apikey: 'Clé API',
      oauthId: 'ID OAuth',
      oauthSecret: 'Secret OAuth',
      shopUuid: 'UUID de la boutique',
      venue: 'Restaurant',
      operator: 'Opérateur',
      posType: 'Type de PDV',
      storeId: 'ID du magasin',
      supportingPos: 'Support du PDV',
    },
  },
  banner: {
    index: 'Gérer les bannières',
    add: 'Créer une bannière',
    table: {
      name: 'Nom',
      type: 'Type',
      linkedCategory: 'Catégorie liée',
      linkedArticle: 'Article lié',
    },
    form: {
      name: 'Nom',
      type: 'Type',
      linkedCategory: 'Catégorie liée',
      linkedArticle: 'Article lié',
      imageDe: 'Image (de)',
      imageEn: 'Image (en)',
      imageFr: 'Image (fr)',
    },
  },
  lightspeed: {
    syncFoodcard: 'Synchroniser',
    success: 'Lightspeed a été autorisé avec succès',
    successDescription:
      "Félicitations ! Lightspeed a été autorisé avec succès. Veuillez contacter votre gestionnaire de compte clé pour finaliser l'intégration. Vous pouvez fermer cette page maintenant.",
    error: "Lightspeed n'a pas pu être autorisé",
    errorDescription:
      "Malheureusement, une erreur inconnue s'est produite lors de l'autorisation de Lightspeed. Veuillez contacter le support ou votre gestionnaire de compte clé. Vous pouvez fermer cette page maintenant.",
    notification: {
      foodcardSyncSuccess: 'Le menu est en cours de synchronisation. Cela prend environ 15 minutes.',
      foodcardSyncError: "Le menu n'a pas pu être synchronisé. Veuillez informer un administrateur.",
      tablesSyncSuccess: 'Les tables sont en cours de synchronisation. Cela prend environ 5 minutes.',
      tablesSyncError: "Les tables n'ont pas pu être synchronisées. Veuillez informer un administrateur.",
    },
    modes: {
      create_and_update: 'Tout synchroniser',
      create_only: 'Synchroniser les nouveaux éléments',
      update_only: 'Synchroniser les modifications',
      price_and_active: 'Synchroniser les prix/visibilités',
      price_only: 'Synchroniser uniquement les prix',
      images_only: 'Synchroniser uniquement les images',
      tables: 'Synchroniser les tables',
    },
  },
  copy_venue: {
    not_selected_to: 'Vous devez sélectionner une destination vers laquelle copier',
    success: 'Le restaurant a été copié avec succès',
    error: 'quelque chose a mal tourné',
    btn_title: 'Copier les paramètres',
    from: 'De',
    to: 'À',
  },
  sync: {
    index: 'Synchronisation',
    sync: 'Synchroniser',
    syncUpsells: 'Synchroniser les ventes incitatives',
    config: 'Configuration',
    created: 'Créé',
    updated: 'Mis à jour',
    deleted: 'Supprimé',
    collapseAll: 'Tout réduire',
    expandAll: 'Tout développer',
    warnings: 'Avertissements',
    directions: {
      d2d: 'Dev-to-Dev',
      d2p: 'Dev-to-Prod',
      p2d: 'Prod-to-Dev',
      p2p: 'Prod-to-Prod',
    },
    notification: {
      running: 'La synchronisation a démarré',
      error: "Une erreur s'est produite. Veuillez vérifier les journaux.",
    },
    modes: {
      'master-to-slaves': 'Maître -> Esclaves',
      'slave-to-slaves': 'Esclave -> Esclaves',
    },
    deleteModes: {
      ignore: 'Aucun changement/Suppression',
      soft: 'Suppression douce',
      hard: 'Suppression définitive',
    },
    table: {
      id: 'Id',
      name: 'Nom',
      user: 'Utilisateur',
      status: 'Statut',
      createdAt: 'Créé',
      today: "Aujourd'hui",
      finishedAt: 'Terminé',
      config: 'Configuration',
      changes: 'Changements',
      stopSync: 'Arrêter la synchronisation',
      refresh: 'Actualiser',
    },
    form: {
      main: 'Restaurant principal (Esclave/Maître)',
      slaves: 'Restaurants esclaves',
      direction: 'De/Vers',
      mode: 'Mode',
      deleteMode: 'Mode de suppression',
      articleCategoryProps: 'Propriétés des catégories',
      categories: 'Catégories',
      articleProps: 'Propriétés des articles',
      venueProps: 'Propriétés des restaurants',
      optionGroupProps: "Propriétés des groupes d'options",
      optionArticleProps: "Propriétés des articles d'option",
      selectAll: 'Tout sélectionner',
      upsells: 'Ventes incitatives',
      useSyncTags: 'Synchroniser en fonction des balises de synchronisation',
    },
    props: {
      articleCategory: {
        sortOrder: 'Ordre de tri',
        visible: 'Visibilité',
        displayMode: "Mode d'affichage",
        displayIdentifiers: "Identifiants d'affichage",
        mainCategory: 'Catégorie principale',
        availableHours: 'Heures disponibles',
        name: 'Nom',
        description: 'Description',
        assets: 'Image principale',
        icon: 'Icône',
        tags: 'Étiquettes',
        constrains: 'Contraintes',
        features: 'Caractéristiques',
        mainRecommendations: 'Recommandations principales',
        printerSortOrder: "Ordre de tri d'imprimante",
      },
      article: {
        price: 'Prix',
        basePrice: 'Prix de base',
        referencePrice: 'Prix de référence',
        taxTakeaway: 'Taxe (À emporter)',
        taxInside: 'Taxe (Sur place)',
        sortOrder: 'Ordre de tri',
        visible: 'Visibilité',
        isActive: 'Statut actif',
        deposit: 'Dépôt',
        isControlArticle: "Indicateur d'article de contrôle",
        internalNote: 'Note interne',
        internalName: 'Nom interne',
        externalId: 'ID externe',
        number: 'Numéro',
        priceIsLocked: 'Verrouillage de prix',
        isNoticeable: 'Remarquable',
        description: 'Description',
        name: 'Nom',
        info: 'Info',
        shortDescription: 'Description courte',
        assets: 'Image principale',
        icon: 'Icône',
        banner: 'Bannière',
        measurement: 'Mesure',
        groupDependencies: 'Dépendances de groupe',
        groups: "Groupes d'options",
        defaults: 'Valeurs par défaut',
        recommendations: 'Recommandations',
        priceByType: 'Prix par type de commande',
        displayPriceByType: 'Prix visible par type de commande',
        availability: 'Disponibilité',
        tags: 'Étiquettes',
        constrains: 'Contraintes',
        counterArticle: 'Article compteur',
        mainRecommendations: 'Recommandations principales',
        articleRelativeBrand: 'Marque',
        styles: 'Styles',
        additives: 'Additifs',
        allergens: 'Allergènes',
        features: 'Caractéristiques',
        traces: 'Traces',
        externalOrderProviderSettings: 'Paramètres des fournisseurs de commande externes',
        loyaltyId: 'ID de fidélité',
        requiredLoyaltyPoints: 'Points de fidélité requis',
        plu: 'PLU',
        gtin: 'GTIN',
        nutritions: 'Valeurs nutritionnelles',
        displayMode: "Mode d'affichage",
        displayModeSot: "Mode d'affichage (Sot)",
        displayModeMobile: "Mode d'affichage (Mobile)",
        manufacturer: 'Fabricant',
        caffeineMg: 'Caféine (mg)',
        alcoholPercentage: "Pourcentage d'alcool",
        availableHours: 'Heures disponibles',
        printerSortOrder: "Ordre de tri d'imprimante",
        dimension: 'Dimensions',
        weight: 'Poids',
        foodInstructions: 'Instructions alimentaires',
        storageInstructions: 'Instructions de stockage',
      },
      venue: {
        movDelivery: 'VMC',
        preorderTakeAway: 'Précommande (À emporter)',
        preorderIn: 'Précommande (Sur place)',
        deliveryEnabled: 'Précommande (Livraison)',
        sendProvisionReportPeriod: 'Rapport de commission',
        isServiceActivated: 'Statut du service',
        offsets: 'Décalages',
        invoiceReceiver: 'Destinataire de la facture',
        slot: 'Créneaux',
        legal: 'Juridique',
        openingHours: "Heures d'ouverture",
        deliveryHours: 'Heures de livraison',
        nutritionTable: 'Tableau nutritionnel',
        nutritionInfo: 'Informations nutritionnelles',
      },
      optionGroup: {
        hasMultiple: 'Sélection multiple',
        limit: 'Limite',
        sortOrder: 'Ordre de tri',
        requiredAmount: 'Quantité requise',
        name: 'Nom',
        description: 'Description',
        shortDescription: 'Description courte',
        backgroundImage: "Image d'arrière-plan",
        tags: 'Étiquettes',
        displayMode: "Mode d'affichage",
        displayModeSot: "Mode d'affichage (Sot)",
        displayModeMobile: "Mode d'affichage (Mobile)",
        printerSortOrder: "Ordre de tri d'imprimante",
      },
      optionArticle: {
        availableHours: 'Heures disponibles',
        price: 'Prix',
        basePrice: 'Prix de base',
        referencePrice: 'Prix de référence',
        taxTakeaway: 'Taxe (À emporter)',
        taxInside: 'Taxe (Sur place)',
        sortOrder: 'Ordre de tri',
        visible: 'Visibilité',
        isActive: 'Statut actif',
        deposit: 'Dépôt',
        isControlArticle: "Indicateur d'article de contrôle",
        internalNote: 'Note interne',
        internalName: 'Nom interne',
        foodInstructions: 'Instructions alimentaires',
        storageInstructions: 'Instructions de stockage',
        externalId: 'ID externe',
        optionNumber: "Numéro d'option",
        number: 'Numéro',
        priceIsLocked: 'Verrouillage de prix',
        isNoticeable: 'Remarquable',
        description: 'Description',
        name: 'Nom',
        info: 'Info',
        shortDescription: 'Description courte',
        assets: 'Image principale',
        icon: 'Icône',
        banner: 'Bannière',
        measurement: 'Mesure',
        groupDependencies: 'Dépendances de groupe',
        groups: "Groupes d'options",
        defaults: 'Valeurs par défaut',
        recommendations: 'Recommandations',
        priceByType: 'Prix par type de commande',
        displayPriceByType: 'Prix visible par type de commande',
        availability: 'Disponibilité',
        tags: 'Étiquettes',
        constrains: 'Contraintes',
        counterArticle: 'Article compteur',
        mainRecommendations: 'Recommandations principales',
        requirements: 'Exigences des articles',
        articleRelativeBrand: 'Marque',
        styles: 'Styles',
        additives: 'Additifs',
        allergens: 'Allergènes',
        features: 'Caractéristiques',
        traces: 'Traces',
        externalOrderProviderSettings: 'Paramètres des fournisseurs de commande externes',
        loyaltyId: 'ID de fidélité',
        requiredLoyaltyPoints: 'Points de fidélité requis',
        plu: 'PLU',
        gtin: 'GTIN',
        nutritions: 'Valeurs nutritionnelles',
        manufacturer: 'Fabricant',
        caffeineMg: 'Caféine (mg)',
        alcoholPercentage: "Pourcentage d'alcool",
        printerSortOrder: "Ordre de tri d'imprimante",
        dimensions: 'Dimensions',
        weight: 'Poids',
      },
      upsell: {
        addon: 'Vente incitative de panier',
        goal: "Vente incitative d'arrondi",
        upgrade: "Vente incitative d'article",
      },
    },
  },
  aggregatorSyncs: {
    index: "Synchronisations d'agrégateurs",
    wolt: 'Wolt',
    uberEats: 'Uber Eats',
    jet: 'Jet',
    deliveroo: 'Deliveroo',
    noWolt: 'Aucune donnée Wolt disponible.',
    noJet: 'Aucune donnée Jet disponible.',
    noUberEats: 'Aucune donnée Uber Eats disponible.',
    noDeliveroo: 'Aucune donnée Deliveroo disponible.',
    table: {
      name: 'Nom',
      user: 'Utilisateur',
      status: 'Statut',
      createdAt: 'Créé',
      finishedAt: 'Terminé',
    },
    filter: {
      status: 'Sélectionner le statut',
    },
    status: {
      created: 'Créé',
      in_progress: 'En cours',
      done: 'Terminé',
      failed: 'Échoué',
    },
  },
  posSync: {
    index: 'POS Sync',
    table: {
      venue: 'Restaurant',
      status: 'Statut',
      user: 'Utilisateur',
      syncMode: 'Mode de synchronisation',
      errorMessage: "Message d'erreur",
      createdAt: 'Créé le',
      startedAt: 'Démarré le',
      finishedAt: 'Terminé le',
      failedAt: 'Échoué le',
    },
  },
  orderProviders: {
    wolt: {
      success: {
        title: 'Le restaurant a été connecté avec succès à Wolt',
        description:
          'Votre restaurant a été connecté avec succès à Wolt. Vous pouvez maintenant synchroniser votre carte alimentaire et recevoir des commandes.',
      },
      error: {
        title: "Le restaurant n'a pas pu être connecté à Wolt",
        description: "Une erreur s'est produite. Veuillez contacter notre support :",
      },
    },
    uberEats: {
      success: {
        title: 'Le restaurant a été connecté avec succès à Uber Eats',
        description:
          'Votre restaurant a été connecté avec succès à Uber Eats. Vous pouvez maintenant synchroniser votre carte alimentaire et recevoir des commandes.',
      },
      error: {
        title: "Le restaurant n'a pas pu être connecté à Uber Eats",
        description: "Une erreur s'est produite. Veuillez contacter notre support :",
      },
    },
  },
  simphony: {
    syncFoodcard: 'Synchroniser les prix/visibilités',
    syncPrices: 'Synchroniser uniquement les prix',
    syncActive: 'Synchroniser uniquement les visibilités',
    refreshCnc: 'Rafraîchir CNC',
    notification: {
      foodcardSyncSuccess: 'Les prix/visibilités ont été synchronisés avec succès.',
      foodcardSyncError: 'Impossible de synchroniser les prix/visibilités. Veuillez vérifier les journaux.',
      pricesSyncSuccess: 'Les prix ont été synchronisés avec succès.',
      pricesSyncError: 'Impossible de synchroniser les prix. Veuillez vérifier les journaux.',
      activeSyncSuccess: 'Les visibilités ont été synchronisées avec succès.',
      activeSyncError: 'Impossible de synchroniser les visibilités. Veuillez vérifier les journaux.',
      refreshCncSuccess: 'Le CNC a été rafraîchi avec succès.',
      refreshCncError: 'Impossible de rafraîchir le CNC. Veuillez vérifier les journaux.',
    },
  },
  kost: {
    syncFoodcard: 'Synchroniser la carte alimentaire',
    notification: {
      foodcardSyncSuccess: 'La carte alimentaire a été synchronisée avec succès.',
      foodcardSyncError: 'Impossible de synchroniser la carte alimentaire. Veuillez vérifier les journaux.',
    },
  },
  ncr: {
    syncFoodcard: 'Synchroniser la carte alimentaire',
    notification: {
      foodcardSyncSuccess: 'La carte alimentaire a été synchronisée avec succès.',
      foodcardSyncError: 'Impossible de synchroniser la carte alimentaire. Veuillez vérifier les journaux.',
    },
  },
  fullcircle: {
    sync: 'Sync',
    syncMenu: 'Sync menu',
    notification: {
      menuSyncQueued: 'Sync has been queued. Follow it under sync jobs.',
      menuSyncError: 'Could not queue the sync. Please check the logs.',
    },
    modes: {
      full: 'Full sync',
      price_only: 'Only sync prices',
    },
  },
  revel: {
    sync: 'Synchroniser',
    syncMenu: 'Synchroniser le menu',
    notification: {
      menuSyncSuccess: 'Le menu a été synchronisé avec succès.',
      menuSyncError: 'Impossible de synchroniser le menu. Veuillez vérifier les journaux.',
    },
    modes: {
      full: 'Tout synchroniser',
      add_only: 'Ajouter seulement',
      price_only: 'Synchroniser uniquement les prix',
      active_only: 'Synchroniser uniquement les visibilités',
    },
  },
  lina: {
    syncPrices: 'Synchroniser les prix',
    notification: {
      pricesSyncSuccess: 'Les prix ont été synchronisés avec succès.',
      pricesSyncError: 'Impossible de synchroniser les prix. Veuillez vérifier les journaux.',
    },
  },
  ui: {
    banner: {
      index: 'Bannières',
      overview: "Vue d'ensemble",
      general: 'Détails',
      add: 'Créer une bannière',
      create: 'Créer une nouvelle bannière',
      edit: 'Modifier la bannière',
      empty: "Il semble que vous n'ayez pas encore ajouté de bannières. Créez votre première bannière maintenant !",
    },
    card: {
      index: 'Cartes',
      overview: "Vue d'ensemble",
      general: 'Détails',
      add: 'Créer une carte',
      create: 'Créer une nouvelle carte',
      edit: 'Modifier la carte',
      empty: "Il semble que vous n'ayez pas encore ajouté de cartes. Créez votre première carte maintenant !",
    },
    slider: {
      index: 'Curseurs',
      overview: "Vue d'ensemble",
      general: 'Détails',
      add: 'Créer un curseur',
      create: 'Créer un nouveau curseur',
      edit: 'Modifier le curseur',
      empty: "Il semble que vous n'ayez pas encore ajouté de curseurs. Créez votre premier curseur maintenant !",
    },
    form: {
      customerGroup: 'Groupe de clients',
      title: 'Titre',
      identifier: 'Identifiant',
      textColor: 'Couleur du texte',
      backgroundColor: "Couleur d'arrière-plan",
      backgroundImage: "Image d'arrière-plan",
      htmlContent: 'Contenu HTML',
      primaryClickAction: 'Action de clic principal',
      type: 'Type',
      value: 'Valeur',
      label: 'Étiquette',
      addAction: 'Ajouter une action',
      removeAction: "Supprimer l'action",
      slides: 'Diapositives',
      actionType: "Type d'action",
      description: 'Description',
      action: 'Actions',
    },
  },
  releases: {
    index: 'Versions',
    overview: "Vue d'ensemble",
    general: 'Détails',
    add: 'Créer une version',
    create: 'Créer une nouvelle version',
    edit: 'Modifier la version',
    empty: "Il semble que vous n'ayez pas encore ajouté de versions. Créez votre première version maintenant !",
    form: {
      customerGroup: 'Groupe de clients',
      platform: 'Plateforme',
      version: 'Version',
      forceUpdate: 'Mise à jour forcée',
      description: 'Description',
      link: 'Lien',
      isLatest: 'Version actuelle',
      isLatestHint: 'Si le champ est actif, la version actuelle sera écrasée.',
      platforms: {
        IOS: 'iOS',
        ANDROID: 'Android',
      },
    },
  },
  auditing: {
    index: 'Audit',
    overview: "Vue d'ensemble",
    table: {
      action: 'Action',
      message: 'Sujet',
      target: 'Ressource',
      actor: 'Utilisateur',
      changes: 'Changements',
      createdAt: 'Date',
      venue: 'Restaurant',
      customerGroup: 'Groupe de clients',
    },
  },
  enrollments: {
    index: 'Inscriptions',
    overview: "Vue d'ensemble",
    accept: 'Accepter',
    reject: 'Rejeter',
    comment: 'Commentaire',
    table: {
      deviceType: "Type d'appareil",
      serialNumber: 'Numéro de série',
      venue: 'Restaurant',
      appInformation: 'Application',
      role: 'Rôle',
      enrollmentStatus: 'Statut',
      rolloutStatus: 'Statut de déploiement',
      isActive: 'Actif',
      venues: 'Restaurants',
      reviewerId: 'ID de relecteur',
    },
  },
  campaign: {
    index: 'Campagne',
    overview: "Vue d'ensemble",
    general: 'Détails',
    add: 'Créer une campagne',
    create: 'Créer une nouvelle campagne',
    edit: 'Modifier la campagne',
    empty: "Il semble que vous n'ayez pas encore ajouté de campagnes. Créez votre première campagne maintenant !",
    form: {
      customerGroup: 'Groupe de clients',
      name: 'Nom',
      content: 'Contenu',
      subject: 'Sujet',
      clickAction: 'Action de clic',
      url: 'URL',
      venues: 'Restaurants',
      status: 'Statut',
      error: 'Erreur',
      scheduledAt: 'Planifié',
    },
    table: {
      customerGroup: 'Sélectionner le groupe de clients',
    },
  },
  seasonPass: {
    index: 'Passe de saison',
    warning: 'Une importation réussie écrase toutes les entrées existantes.',
    upload: 'Télécharger CSV',
    csv: 'Fichier CSV de passe de saison',
    successfulUpload: 'Votre fichier CSV de passe de saison a été téléchargé avec succès',
  },
  upsell: {
    index: 'Ventes incitatives',
    overview: "Vue d'ensemble",
    types: {
      addon: 'Vente incitative de panier',
      goal: "Vente incitative d'arrondi",
      upgrade: "Vente incitative d'article",
    },
    table: {
      position: 'Position',
      article: 'Article',
      upgradeFrom: 'PLU Petit',
      upgradeTo: 'PLU Grand',
      mov: 'Valeur minimale de commande',
      roundTo: 'Arrondi à',
      articles: 'PLU à ajouter',
      plu: 'PLU',
    },
    form: {
      position: 'Position',
      article: 'Article',
      upgradeFrom: 'PLU Petit',
      upgradeTo: 'PLU Grand',
      mov: 'Valeur minimale de commande',
      roundTo: 'Arrondi à',
      articles: 'PLU à ajouter',
      isMaster: 'Est maître',
      isMasterNotice:
        "N'oubliez pas de définir l'indicateur \"Est maître\" (si nécessaire) avant d'ajouter le premier élément. Sinon, vous ne pourrez pas le modifier plus tard.",
    },
  },
  healthCheck: {
    index: 'Healthcheck',
    overview: "Vue d'ensemble",
    general: 'Détails',
    add: 'Créer un Healthcheck',
    create: 'Créer un nouveau Healthcheck',
    edit: 'Modifier le Healthcheck',
    empty: "Il semble que vous n'ayez pas encore ajouté de Healthchecks. Créez votre premier Healthcheck maintenant!",
    table: {
      venues: 'Venues',
      customerGroup: 'Groupe de clients',
      lastRunAt: 'Dernière exécution',
      status: 'Statut',
      errorList: 'Erreurs',
      article: 'Article',
      category: 'Catégorie',
      type: 'Type',
    },
    form: {
      venues: 'Venues',
      customerGroup: 'Groupe de clients',
    },
  },
  smoothrPay: {
    open: 'Ouvrir',
    adyen: {
      merchant: 'Marchand',
      noMerchants: 'Aucun marchand configuré pour l’instant.',
      needsAccountHolder: 'Créez d’abord le titulaire du compte — les transactions et versements y sont rattachés.',
      setupFailed: 'Impossible de charger les composants Adyen.',
      retry: 'Réessayer',
    },
    payments: {
      title: 'Paiements',
      subtitle: 'Transactions par marchand Smoothr Pay, fournies par Adyen.',
      selectMerchant: 'Sélectionnez un marchand pour voir ses transactions.',
    },
    payouts: {
      title: 'Versements',
      subtitle: 'Versements par marchand Smoothr Pay, fournis par Adyen.',
      selectMerchant: 'Sélectionnez un marchand pour voir ses versements.',
    },
    index: 'Smoothr Pay',
    subtitle: 'Marchands, provisionnement Adyen et boutiques des sites',
    columns: {
      merchant: 'Marchand',
      owner: 'Propriétaire',
      status: 'Statut',
      verification: 'Vérification',
      createdAt: 'Créé le',
    },
    status: {
      draft: 'Brouillon',
      invited: 'Invité',
      onboarding: 'Intégration',
      active: 'Actif',
      suspended: 'Suspendu',
      closed: 'Fermé',
    },
    channels: { ecom: 'En ligne', pos: 'Point de vente' },
    verification: { payIn: 'Encaissement', payOut: 'Versement', problems: 'problèmes' },
    create: {
      button: 'Ajouter un marchand',
      title: 'Nouveau marchand',
      businessLine: 'Secteur d’activité',
      webAddressRequired: 'Un secteur qui vend en ligne exige une adresse web.',
      webAddressInvalid: 'L’adresse web doit commencer par http:// ou https://.',
      ownerRequired: 'Choisissez l’utilisateur à qui appartient cette configuration.',
    },
    fields: {
      merchantAccount: 'Compte marchand Adyen',
      defaultAccount: 'par défaut',
      legalName: 'Raison sociale',
      description: 'Description',
      country: 'Pays',
      channels: 'Canaux de vente',
      balanceAccount: 'Compte de solde',
      owner: 'Propriétaire',
      industryCode: 'Code d’activité',
      salesChannels: 'Canaux de vente',
      webAddress: 'Adresse web',
      shopperStatement: 'Libellé sur le relevé',
      phoneNumber: 'Numéro de téléphone',
      line1: 'Rue et numéro',
      line2: 'Complément d’adresse',
      postalCode: 'Code postal',
      city: 'Ville',
      stateOrProvince: 'Région',
      splitConfiguration: 'Configuration de partage',
    },
    hints: {
      ownerSelf: 'La configuration est créée pour vous — seuls les admins peuvent la créer au nom d’un autre.',
      ownerAdmin: 'Recherchez par nom ou e-mail.',
      industryCode: 'Code NAICS à six chiffres attendu par Adyen, p. ex. 722511',
      webAddress: 'Requis si le secteur vend en ligne',
      shopperStatement: 'Apparaît sur le relevé bancaire, 22 caractères max.',
    },
    reports: {
      title: 'Relevés',
      subtitle: 'Relevés de règlement par marchand Smoothr Pay, un par mois.',
      selectMerchant: 'Sélectionnez un marchand pour voir ses relevés.',
      none: 'Aucun relevé généré pour ce marchand.',
      loadError: 'Impossible de charger les relevés.',
      generating: 'Le document est en cours de génération — réessayez dans un instant.',
      downloadError: 'Impossible d’obtenir le lien de téléchargement.',
      columns: {
        period: 'Période',
        gross: 'Chiffre d’affaires',
        fees: 'Frais',
        net: 'Net',
        payouts: 'Versé',
        generatedAt: 'Généré',
        download: 'Téléchargement',
      },
      status: {
        pending: 'En attente',
        generated: 'Généré',
        sent: 'Envoyé',
        failed: 'Échec',
      },
    },
    kycIssues: {
      title: '{count} problème de vérification ouvert | {count} problèmes de vérification ouverts',
      unknown: 'Problème signalé sans message',
    },
    kyc: {
      title: 'Ouvrir le lien d’onboarding',
      hint: 'Votre navigateur a bloqué le nouvel onglet. Le lien n’est valable que quelques minutes.',
      open: 'Ouvrir l’onboarding',
      close: 'Fermer',
    },
    provisioning: {
      title: 'Provisionnement Adyen',
      hint: 'S’exécute dans l’ordre. Chaque étape est répétable jusqu’à ce qu’Adyen l’accepte.',
      run: 'Exécuter',
      again: 'Relancer',
      steps: {
        legalEntity: 'Entité juridique',
        businessLines: 'Secteurs d’activité',
        accountHolder: 'Titulaire du compte',
        balanceAccounts: 'Comptes de solde',
        kyc: 'Intégration KYC',
      },
      descriptions: {
        legalEntity: 'Crée l’entité juridique chez Adyen',
        businessLines: 'Crée un secteur d’activité par secteur configuré',
        accountHolder: 'Crée le titulaire du compte',
        balanceAccounts: 'Crée les comptes de solde',
        kyc: 'Ouvre le lien d’intégration hébergé pour le marchand',
      },
    },
    businessLines: {
      title: 'Secteurs d’activité',
      adyenId: 'Chez Adyen',
      notCreated: 'pas encore créé',
      editTitle: 'Modifier le secteur d’activité',
      webAddressRequired: 'Un secteur qui vend en ligne doit conserver une adresse web.',
    },
    stores: {
      title: 'Sites et boutiques',
      venue: 'Site',
      adyenStore: 'Boutique Adyen',
      split: 'Configuration de partage',
      paymentMethods: 'Moyens de paiement',
      close: 'Fermer la boutique',
      editSplit: 'Profil de partage',
      splitDialog: {
        title: 'Changer le profil de partage',
        message: 'Remplace le profil utilisé par {venue}.',
        required: 'Choisissez un profil de partage.',
        noChanges: 'C’est déjà le profil de cette boutique.',
      },
      closeConfirm: 'Fermer cette boutique ? Adyen cessera d’accepter les paiements pour ce site.',
      none: 'Aucun site attribué pour l’instant.',
      assign: 'Attribuer un site',
      assignButton: 'Créer la boutique',
      needsBusinessLine: 'Une boutique exige un secteur d’activité chez Adyen — exécutez d’abord l’étape des secteurs.',
      status: { pending: 'En attente', active: 'Actif', inactive: 'Inactif', closed: 'Fermé' },
    },
    paymentMethods: {
      title: 'Moyens de paiement',
      method: 'Moyen',
      state: 'État',
      none: 'Aucun moyen de paiement demandé pour l’instant.',
      add: 'Demander des moyens de paiement',
      request: 'Demander',
      status: { pending: 'En attente', active: 'Actif', disabled: 'Désactivé' },
      applePayDomains: 'Domaines Apple Pay',
      applePayDomainsHint: 'Séparés par des virgules, au moins un',
      applePayDomainsRequired: 'Apple Pay exige au moins un domaine.',
      googlePayMerchantId: 'ID marchand Google Pay',
      googlePayMerchantIdHint: '16 à 20 caractères',
      googlePayMerchantIdRequired: 'L’ID marchand Google Pay doit compter 16 à 20 caractères.',
      amexServiceLevel: 'Niveau de service Amex',
      amex: { noContract: 'Sans contrat', gateway: 'Contrat gateway', paymentDesignator: 'Contrat payment designator' },
    },
    detail: {
      title: 'Marchand',
      owner: 'Propriétaire',
      payIn: 'Encaissement autorisé',
      payOut: 'Versement autorisé',
      payout: 'Compte de versement',
      invite: 'Envoyer l’invitation',
      resetToDraft: 'Remettre en brouillon',
      resetConfirm: 'Remettre cette configuration en brouillon ?',
      notFound: 'Cette configuration marchand n’existe pas.',
      back: 'Retour à la liste',
    },
    notification: {
      loadError: 'Impossible de charger les configurations marchand.',
      created: 'Configuration marchand créée.',
      createError: 'Impossible de créer la configuration marchand.',
      stepDone: 'Étape de provisionnement terminée.',
      stepFailed: 'L’étape de provisionnement a échoué.',
      kycStarted: 'Lien d’intégration ouvert.',
      businessLineUpdated: 'Secteur d’activité mis à jour.',
      businessLineError: 'Impossible de mettre à jour le secteur d’activité.',
      storeCreated: 'Boutique créée.',
      storeClosed: 'Boutique fermée.',
      splitAttached: 'Profil de partage attribué.',
      splitError: 'Impossible d’attribuer le profil de partage.',
      storeError: 'La requête boutique a échoué.',
      methodsRequested: 'Moyens de paiement demandés.',
      methodRemoved: 'Moyen de paiement supprimé.',
      methodsError: 'La requête de moyens de paiement a échoué.',
      invited: 'Invitation envoyée.',
      inviteError: 'Impossible d’envoyer l’invitation.',
      resetToDraft: 'Configuration remise en brouillon.',
      resetError: 'Impossible de réinitialiser la configuration.',
    },
  },
};
